/**
 * Default roles
 */
const ROLE_SUPER_ADMIN = 'Super admin';
const ROLE_CLIENT_ADMIN = 'Client admin';
const ROLE_PARTITION_ADMIN = 'Partition admin';
const ROLE_VALIDATOR = 'Validator';
const ROLE_MEMBER = 'Member';

/**
 * Default model permission
 */
const MODEL_VIEW = 'view';
const MODEL_EDIT = 'update';
const MODEL_DELETE = 'delete';
const MODEL_VIEW_POLICY = 'view_policy';
const MODEL_VIEW_DATA_SUBJECT = 'view_data_subject';
const MODEL_VIEW_RETENTION_RULE = 'view_retention_rule';
const MODEL_VIEW_ORGANIZATION = 'view_organization';
const MODEL_VIEW_INTEGRITY_CONTROL = 'view_integrity_control';
const MODEL_VIEW_SYSTEM = 'view_system';
const MODEL_VIEW_THIRD_PARTY_SOURCE = 'view_third_party_source';
const MODEL_VIEW_THIRD_PARTY_RECEIVER = 'view_third_party_receiver';
const MODEL_VIEW_LEGAL_BASIS = 'view_legal_basis';
const MODEL_VIEW_INFORMATION_OBLIGATION = 'view_information_obligation';
const MODEL_VIEW_CONFIDENTIALITY = 'view_confidentiality';
const MODEL_VIEW_INTEGRITY = 'view_integrity';
const MODEL_VIEW_AVAILABILITY = 'view_availability';
const MODEL_VIEW_DATA_OBJECT = 'view_data_object';
const MODEL_VIEW_THIRD_PARTY = 'view_third_party';
const MODEL_VIEW_ACCESS_CONTROL = 'view_access_control';
const MODEL_VIEW_LOG_MANAGEMENT = 'view_log_management';
const MODEL_VIEW_NETWORK = 'view_network';
const MODEL_VIEW_DATA_DISCOVERY = 'view_data_discovery';
const MODEL_VIEW_PRINCIPLES_OF_PROPORTIONALITY = 'view_principles_of_proportionality';
const MODEL_VIEW_PROCESSING_TYPE = 'view_processing_type';

/**
 * Maintenance permissions
 */
const MAINTENANCE_VIEW = 'view maintenance';

/**
 * User permissions
 */
const USER_CREATE = 'create user';
const USER_VIEW = 'view user';
const USER_VIEW_OWN = 'view own user';
const USER_EDIT = 'edit user';
const USER_EDIT_OWN = 'edit own user';
const USER_DELETE = 'delete user';
const USER_DELETE_OWN = 'delete own user';

/**
 * Client permissions
 */
const CLIENT_CREATE = 'create client';
const CLIENT_VIEW = 'view client';
const CLIENT_VIEW_OWN = 'view own client';
const CLIENT_EDIT = 'edit client';
const CLIENT_EDIT_OWN = 'edit own client';
const CLIENT_DELETE = 'delete client';
const CLIENT_DELETE_OWN = 'delete own client';
const CLIENT_ADD_USER = 'add user to client';
const CLIENT_REMOVE_USER = 'remove user from client';

/**
 * Partition permissions
 */
const PARTITION_CREATE = 'create partition';
const PARTITION_VIEW = 'view partition';
const PARTITION_VIEW_OWN = 'view own partition';
const PARTITION_EDIT = 'edit partition';
const PARTITION_EDIT_OWN = 'edit own partition';
const PARTITION_DELETE = 'delete partition';
const PARTITION_DELETE_OWN = 'delete own partition';
const PARTITION_ADD_USER = 'add user to partition';
const PARTITION_REMOVE_USER = 'remove user from partition';

/**
 * Third party permissions
 */
const THIRD_PARTY_CREATE = 'create third party';
const THIRD_PARTY_VIEW = 'view third party';
const THIRD_PARTY_VIEW_OWN = 'view own third party';
const THIRD_PARTY_EDIT = 'edit third party';
const THIRD_PARTY_EDIT_OWN = 'edit own third party';
const THIRD_PARTY_DELETE = 'delete third party';
const THIRD_PARTY_DELETE_OWN = 'delete own third party';
const THIRD_PARTY_VALIDATE = 'validate third party';
const THIRD_PARTY_VALIDATE_OWN = 'validate own third party';

/**
 * Policy permissions
 */
const POLICY_CREATE = 'create policy';
const POLICY_VIEW = 'view policy';
const POLICY_VIEW_OWN = 'view own policy';
const POLICY_EDIT = 'edit policy';
const POLICY_EDIT_OWN = 'edit own policy';
const POLICY_DELETE = 'delete policy';
const POLICY_DELETE_OWN = 'delete own policy';
const POLICY_VALIDATE = 'validate policy';
const POLICY_VALIDATE_OWN = 'validate own policy';

/**
 * Measure permissions
 */
const MEASURE_CREATE = 'create measure';
const MEASURE_VIEW = 'view measure';
const MEASURE_VIEW_OWN = 'view own measure';
const MEASURE_EDIT = 'edit measure';
const MEASURE_EDIT_OWN = 'edit own measure';
const MEASURE_DELETE = 'delete measure';
const MEASURE_DELETE_OWN = 'delete own measure';

/**
 * Measure category permissions
 */
const MEASURE_CATEGORY_CREATE = 'create measure category';
const MEASURE_CATEGORY_VIEW = 'view measure category';
const MEASURE_CATEGORY_VIEW_OWN = 'view own measure category';
const MEASURE_CATEGORY_EDIT = 'edit measure category';
const MEASURE_CATEGORY_EDIT_OWN = 'edit own measure category';
const MEASURE_CATEGORY_DELETE = 'delete measure category';
const MEASURE_CATEGORY_DELETE_OWN = 'delete own measure category';


/**
 * Incident category permissions
 */
const INCIDENT_CATEGORY_CREATE = 'create incident category';
const INCIDENT_CATEGORY_VIEW = 'view incident category';
const INCIDENT_CATEGORY_VIEW_OWN = 'view own incident category';
const INCIDENT_CATEGORY_EDIT = 'edit incident category';
const INCIDENT_CATEGORY_EDIT_OWN = 'edit own incident category';
const INCIDENT_CATEGORY_DELETE = 'delete incident category';
const INCIDENT_CATEGORY_DELETE_OWN = 'delete own incident category';

/**
 * Incident category question permissions
 */
const INCIDENT_CATEGORY_QUESTION_CREATE = 'create incident category question';
const INCIDENT_CATEGORY_QUESTION_VIEW = 'view incident category question';
const INCIDENT_CATEGORY_QUESTION_VIEW_OWN = 'view own incident category question';
const INCIDENT_CATEGORY_QUESTION_EDIT = 'edit incident category question';
const INCIDENT_CATEGORY_QUESTION_EDIT_OWN = 'edit own incident category question';
const INCIDENT_CATEGORY_QUESTION_DELETE = 'delete incident category question';
const INCIDENT_CATEGORY_QUESTION_DELETE_OWN = 'delete own incident category question';

/**
 * Incident category system permissions
 */
const INCIDENT_CATEGORY_SYSTEM_CREATE = 'create incident category system';
const INCIDENT_CATEGORY_SYSTEM_CREATE_OWN = 'create own incident category system';
const INCIDENT_CATEGORY_SYSTEM_VIEW = 'view incident category system';
const INCIDENT_CATEGORY_SYSTEM_VIEW_OWN = 'view own incident category system';
const INCIDENT_CATEGORY_SYSTEM_EDIT = 'edit incident category system';
const INCIDENT_CATEGORY_SYSTEM_EDIT_OWN = 'edit own incident category system';
const INCIDENT_CATEGORY_SYSTEM_DELETE = 'delete incident category system';
const INCIDENT_CATEGORY_SYSTEM_DELETE_OWN = 'delete own incident category system';

/**
 * Incident category risk scenario permissions
 */
const INCIDENT_CATEGORY_RISK_SCENARIO_CREATE = 'create incident category risk  scenario';
const INCIDENT_CATEGORY_RISK_SCENARIO_CREATE_OWN = 'create own incident category risk  scenario';
const INCIDENT_CATEGORY_RISK_SCENARIO_VIEW = 'view incident category risk  scenario';
const INCIDENT_CATEGORY_RISK_SCENARIO_VIEW_OWN = 'view own incident category risk  scenario';
const INCIDENT_CATEGORY_RISK_SCENARIO_EDIT = 'edit incident category risk  scenario';
const INCIDENT_CATEGORY_RISK_SCENARIO_EDIT_OWN = 'edit own incident category risk  scenario';
const INCIDENT_CATEGORY_RISK_SCENARIO_DELETE = 'delete incident category risk  scenario';
const INCIDENT_CATEGORY_RISK_SCENARIO_DELETE_OWN = 'delete own incident category risk  scenario';


/**
 * Activity measure permissions
 */
const ACTIVITY_MEASURE_CREATE = 'create activity measure';
const ACTIVITY_MEASURE_CREATE_OWN = 'create own activity measure';
const ACTIVITY_MEASURE_VIEW = 'view activity measure';
const ACTIVITY_MEASURE_VIEW_OWN = 'view own activity measure';
const ACTIVITY_MEASURE_EDIT = 'edit activity measure';
const ACTIVITY_MEASURE_EDIT_OWN = 'edit own activity measure';
const ACTIVITY_MEASURE_DELETE = 'delete activity measure';
const ACTIVITY_MEASURE_DELETE_OWN = 'delete own activity measure';
const ACTIVITY_MEASURE_VALIDATE = 'validate activity measure';
const ACTIVITY_MEASURE_VALIDATE_OWN = 'validate own activity measure';

/**
 * System measure permissions
 */
const SYSTEM_MEASURE_CREATE = 'create system measure';
const SYSTEM_MEASURE_CREATE_OWN = 'create own system measure';
const SYSTEM_MEASURE_VIEW = 'view system measure';
const SYSTEM_MEASURE_VIEW_OWN = 'view own system measure';
const SYSTEM_MEASURE_EDIT = 'edit system measure';
const SYSTEM_MEASURE_EDIT_OWN = 'edit own system measure';
const SYSTEM_MEASURE_DELETE = 'delete system measure';
const SYSTEM_MEASURE_DELETE_OWN = 'delete own system measure';
const SYSTEM_MEASURE_VALIDATE = 'validate system measure';
const SYSTEM_MEASURE_VALIDATE_OWN = 'validate own system measure';

/**
 * Third party measure permissions
 */
const THIRD_PARTY_MEASURE_CREATE = 'create third party measure';
const THIRD_PARTY_MEASURE_CREATE_OWN = 'create own third party measure';
const THIRD_PARTY_MEASURE_VIEW = 'view third party measure';
const THIRD_PARTY_MEASURE_VIEW_OWN = 'view own third party measure';
const THIRD_PARTY_MEASURE_EDIT = 'edit third party measure';
const THIRD_PARTY_MEASURE_EDIT_OWN = 'edit own third party measure';
const THIRD_PARTY_MEASURE_DELETE = 'delete third party measure';
const THIRD_PARTY_MEASURE_DELETE_OWN = 'delete own third party measure';
const THIRD_PARTY_MEASURE_VALIDATE = 'validate third party measure';
const THIRD_PARTY_MEASURE_VALIDATE_OWN = 'validate own third party measure';

/**
 * Generic control measure permissions
 */
const GENERIC_CONTROL_MEASURE_CREATE = 'create generic control measure';
const GENERIC_CONTROL_MEASURE_CREATE_OWN = 'create own generic control measure';
const GENERIC_CONTROL_MEASURE_VIEW = 'view generic control measure';
const GENERIC_CONTROL_MEASURE_VIEW_OWN = 'view own generic control measure';
const GENERIC_CONTROL_MEASURE_EDIT = 'edit generic control measure';
const GENERIC_CONTROL_MEASURE_EDIT_OWN = 'edit own generic control measure';
const GENERIC_CONTROL_MEASURE_DELETE = 'delete generic control measure';
const GENERIC_CONTROL_MEASURE_DELETE_OWN = 'delete own generic control measure';
const GENERIC_CONTROL_MEASURE_VALIDATE = 'validate generic control measure';
const GENERIC_CONTROL_MEASURE_VALIDATE_OWN = 'validate own generic control measure';

/**
 * Organizations permissions
 */
const ORGANIZATION_CREATE = 'create organization';
const ORGANIZATION_VIEW = 'view organization';
const ORGANIZATION_VIEW_OWN = 'view own organization';
const ORGANIZATION_EDIT = 'edit organization';
const ORGANIZATION_EDIT_OWN = 'edit own organization';
const ORGANIZATION_DELETE = 'delete organization';
const ORGANIZATION_DELETE_OWN = 'delete own organization';

/**
 * Process group permissions
 */
const PROCESS_GROUP_CREATE = 'create process group';
const PROCESS_GROUP_VIEW = 'view process group';
const PROCESS_GROUP_VIEW_OWN = 'view own process group';
const PROCESS_GROUP_EDIT = 'edit process group';
const PROCESS_GROUP_EDIT_OWN = 'edit own process group';
const PROCESS_GROUP_DELETE = 'delete process group';
const PROCESS_GROUP_DELETE_OWN = 'delete own process group';

/**
 * Legal basis permissions
 */
const LEGAL_BASIS_CREATE = 'create legal basis';
const LEGAL_BASIS_VIEW = 'view legal basis';
const LEGAL_BASIS_VIEW_OWN = 'view own legal basis';
const LEGAL_BASIS_EDIT = 'edit legal basis';
const LEGAL_BASIS_EDIT_OWN = 'edit own legal basis';
const LEGAL_BASIS_DELETE = 'delete legal basis';
const LEGAL_BASIS_DELETE_OWN = 'delete own legal basis';
const LEGAL_BASIS_VALIDATE = 'validate legal basis';
const LEGAL_BASIS_VALIDATE_OWN = 'validate own legal basis';

/**
 * Information obligation permissions
 */
const INFORMATION_OBLIGATION_CREATE = 'create information obligation';
const INFORMATION_OBLIGATION_VIEW = 'view information obligation';
const INFORMATION_OBLIGATION_VIEW_OWN = 'view own information obligation';
const INFORMATION_OBLIGATION_EDIT = 'edit information obligation';
const INFORMATION_OBLIGATION_EDIT_OWN = 'edit own information obligation';
const INFORMATION_OBLIGATION_DELETE = 'delete information obligation';
const INFORMATION_OBLIGATION_DELETE_OWN = 'delete own information obligation';
const INFORMATION_OBLIGATION_VALIDATE = 'validate information obligation';
const INFORMATION_OBLIGATION_VALIDATE_OWN = 'validate own information obligation';

/**
 * Access control permissions
 */
const ACCESS_CONTROL_CREATE = 'create access control';
const ACCESS_CONTROL_VIEW = 'view access control';
const ACCESS_CONTROL_VIEW_OWN = 'view own access control';
const ACCESS_CONTROL_EDIT = 'edit access control';
const ACCESS_CONTROL_EDIT_OWN = 'edit own access control';
const ACCESS_CONTROL_DELETE = 'delete access control';
const ACCESS_CONTROL_DELETE_OWN = 'delete own access control';
const ACCESS_CONTROL_VALIDATE = 'validate access control';
const ACCESS_CONTROL_VALIDATE_OWN = 'validate own access control';

/**
 * Data discovery permissions
 */
const DATA_DISCOVERY_CREATE = 'create data discovery';
const DATA_DISCOVERY_VIEW = 'view data discovery';
const DATA_DISCOVERY_VIEW_OWN = 'view own data discovery';
const DATA_DISCOVERY_EDIT = 'edit data discovery';
const DATA_DISCOVERY_EDIT_OWN = 'edit own data discovery';
const DATA_DISCOVERY_DELETE = 'delete data discovery';
const DATA_DISCOVERY_DELETE_OWN = 'delete own data discovery';
const DATA_DISCOVERY_VALIDATE = 'validate data discovery';
const DATA_DISCOVERY_VALIDATE_OWN = 'validate own data discovery';

/**
 * Log management permissions
 */
const LOG_MANAGEMENT_CREATE = 'create log management';
const LOG_MANAGEMENT_VIEW = 'view log management';
const LOG_MANAGEMENT_VIEW_OWN = 'view own log management';
const LOG_MANAGEMENT_EDIT = 'edit log management';
const LOG_MANAGEMENT_EDIT_OWN = 'edit own log management';
const LOG_MANAGEMENT_DELETE = 'delete log management';
const LOG_MANAGEMENT_DELETE_OWN = 'delete own log management';
const LOG_MANAGEMENT_VALIDATE = 'validate log management';
const LOG_MANAGEMENT_VALIDATE_OWN = 'validate own log management';

/**
 * Risk categories permissions
 */
const RISK_CATEGORY_CREATE = 'create risk category';
const RISK_CATEGORY_VIEW = 'view risk category';
const RISK_CATEGORY_VIEW_OWN = 'view own risk category';
const RISK_CATEGORY_EDIT = 'edit risk category';
const RISK_CATEGORY_EDIT_OWN = 'edit own risk category';
const RISK_CATEGORY_DELETE = 'delete risk category';
const RISK_CATEGORY_DELETE_OWN = 'delete own risk category';

/**
 * Network permissions
 */
const NETWORK_CREATE = 'create network';
const NETWORK_VIEW = 'view network';
const NETWORK_VIEW_OWN = 'view own network';
const NETWORK_EDIT = 'edit network';
const NETWORK_EDIT_OWN = 'edit own network';
const NETWORK_DELETE = 'delete network';
const NETWORK_DELETE_OWN = 'delete own network';
const NETWORK_VALIDATE = 'validate network';
const NETWORK_VALIDATE_OWN = 'validate own network';

/**
 * Data subject permissions
 */
const DATA_SUBJECT_CREATE = 'create data subject';
const DATA_SUBJECT_VIEW = 'view data subject';
const DATA_SUBJECT_VIEW_OWN = 'view own data subject';
const DATA_SUBJECT_EDIT = 'edit data subject';
const DATA_SUBJECT_EDIT_OWN = 'edit own data subject';
const DATA_SUBJECT_DELETE = 'delete data subject';
const DATA_SUBJECT_DELETE_OWN = 'delete own data subject';

/**
 * Retention rule permissions
 */
const RETENTION_RULE_CREATE = 'create retention rule';
const RETENTION_RULE_VIEW = 'view retention rule';
const RETENTION_RULE_VIEW_OWN = 'view own retention rule';
const RETENTION_RULE_EDIT = 'edit retention rule';
const RETENTION_RULE_EDIT_OWN = 'edit own retention rule';
const RETENTION_RULE_DELETE = 'delete retention rule';
const RETENTION_RULE_DELETE_OWN = 'delete own retention rule';

/**
 * Data object permissions
 */
const DATA_OBJECT_CREATE = 'create data object';
const DATA_OBJECT_VIEW = 'view data object';
const DATA_OBJECT_VIEW_OWN = 'view own data object';
const DATA_OBJECT_EDIT = 'edit data object';
const DATA_OBJECT_EDIT_OWN = 'edit own data object';
const DATA_OBJECT_DELETE = 'delete data object';
const DATA_OBJECT_DELETE_OWN = 'delete own data object';
const DATA_OBJECT_VALIDATE = 'validate data object';
const DATA_OBJECT_VALIDATE_OWN = 'validate own data object';

/**
 * Process permissions
 */
const PROCESS_CREATE = 'create process';
const PROCESS_VIEW = 'view process';
const PROCESS_VIEW_OWN = 'view own process';
const PROCESS_EDIT = 'edit process';
const PROCESS_EDIT_OWN = 'edit own process';
const PROCESS_DELETE = 'delete process';
const PROCESS_DELETE_OWN = 'delete own process';

/**
 * Process activity permissions
 */
const PROCESS_ACTIVITY_CREATE = 'create process activity';
const PROCESS_ACTIVITY_CREATE_OWN = 'create own process activity';
const PROCESS_ACTIVITY_VIEW = 'view process activity';
const PROCESS_ACTIVITY_VIEW_OWN = 'view own process activity';
const PROCESS_ACTIVITY_EDIT = 'edit process activity';
const PROCESS_ACTIVITY_EDIT_OWN = 'edit own process activity';
const PROCESS_ACTIVITY_DELETE = 'delete process activity';
const PROCESS_ACTIVITY_DELETE_OWN = 'delete own process activity';

/**
 * Process policy permissions
 */
const PROCESS_POLICY_CREATE = 'create process policy';
const PROCESS_POLICY_CREATE_OWN = 'create own process policy';
const PROCESS_POLICY_VIEW = 'view process policy';
const PROCESS_POLICY_VIEW_OWN = 'view own process policy';
const PROCESS_POLICY_EDIT = 'edit process policy';
const PROCESS_POLICY_EDIT_OWN = 'edit own process policy';
const PROCESS_POLICY_DELETE = 'delete process policy';
const PROCESS_POLICY_DELETE_OWN = 'delete own process policy';

/**
 * Process legal basis permissions
 */
const PROCESS_LEGAL_BASIS_CREATE = 'create process legal basis';
const PROCESS_LEGAL_BASIS_CREATE_OWN = 'create own process legal basis';
const PROCESS_LEGAL_BASIS_VIEW = 'view process legal basis';
const PROCESS_LEGAL_BASIS_VIEW_OWN = 'view own process legal basis';
const PROCESS_LEGAL_BASIS_EDIT = 'edit process legal basis';
const PROCESS_LEGAL_BASIS_EDIT_OWN = 'edit own process legal basis';
const PROCESS_LEGAL_BASIS_DELETE = 'delete process legal basis';
const PROCESS_LEGAL_BASIS_DELETE_OWN = 'delete own process legal basis';
const PROCESS_LEGAL_BASIS_VALIDATE = 'validate process legal basis';
const PROCESS_LEGAL_BASIS_VALIDATE_OWN = 'validate own process legal basis';

/**
 * Process information obligation permissions
 */
const PROCESS_INFORMATION_OBLIGATION_CREATE = 'create process information obligation';
const PROCESS_INFORMATION_OBLIGATION_CREATE_OWN = 'create own process information obligation';
const PROCESS_INFORMATION_OBLIGATION_VIEW = 'view process information obligation';
const PROCESS_INFORMATION_OBLIGATION_VIEW_OWN = 'view own process information obligation';
const PROCESS_INFORMATION_OBLIGATION_EDIT = 'edit process information obligation';
const PROCESS_INFORMATION_OBLIGATION_EDIT_OWN = 'edit own process information obligation';
const PROCESS_INFORMATION_OBLIGATION_DELETE = 'delete process information obligation';
const PROCESS_INFORMATION_OBLIGATION_DELETE_OWN = 'delete own process information obligation';
const PROCESS_INFORMATION_OBLIGATION_VALIDATE = 'validate process information obligation';
const PROCESS_INFORMATION_OBLIGATION_VALIDATE_OWN = 'validate own process information obligation';

/**
 * Process confidentiality permissions
 */
const PROCESS_CONFIDENTIALITY_VIEW = 'view process confidentiality';
const PROCESS_CONFIDENTIALITY_VIEW_OWN = 'view own process confidentiality';
const PROCESS_CONFIDENTIALITY_EDIT = 'edit process confidentiality';
const PROCESS_CONFIDENTIALITY_EDIT_OWN = 'edit own process confidentiality';
const PROCESS_CONFIDENTIALITY_VALIDATE = 'validate process confidentiality';
const PROCESS_CONFIDENTIALITY_VALIDATE_OWN = 'validate own process confidentiality';

/**
 * Process integrity permissions
 */
const PROCESS_INTEGRITY_VIEW = 'view process integrity';
const PROCESS_INTEGRITY_VIEW_OWN = 'view own process integrity';
const PROCESS_INTEGRITY_EDIT = 'edit process integrity';
const PROCESS_INTEGRITY_EDIT_OWN = 'edit own process integrity';
const PROCESS_INTEGRITY_VALIDATE = 'validate process integrity';
const PROCESS_INTEGRITY_VALIDATE_OWN = 'validate own process integrity';

/**
 * Process availability permissions
 */
const PROCESS_AVAILABILITY_VIEW = 'view process availability';
const PROCESS_AVAILABILITY_VIEW_OWN = 'view own process availability';
const PROCESS_AVAILABILITY_EDIT = 'edit process availability';
const PROCESS_AVAILABILITY_EDIT_OWN = 'edit own process availability';
const PROCESS_AVAILABILITY_VALIDATE = 'validate process availability';
const PROCESS_AVAILABILITY_VALIDATE_OWN = 'validate own process availability';

/**
 * Process risk profile permissions
 */
const PROCESS_RISK_VIEW = 'view process risk profile';
const PROCESS_RISK_VIEW_OWN = 'view own process risk profile';
const PROCESS_RISK_EDIT = 'edit process risk profile';
const PROCESS_RISK_EDIT_OWN = 'edit own process risk profile';
const PROCESS_RISK_VALIDATION = 'validate process risk profile';
const PROCESS_RISK_VALIDATION_OWN = 'validate own process risk profile';

/**
 * System permissions
 */
const SYSTEM_CREATE = 'create system';
const SYSTEM_VIEW = 'view system';
const SYSTEM_VIEW_OWN = 'view own system';
const SYSTEM_EDIT = 'edit system';
const SYSTEM_EDIT_OWN = 'edit own system';
const SYSTEM_DELETE = 'delete system';
const SYSTEM_DELETE_OWN = 'delete own system';

/**
 * System policy permissions
 */
const SYSTEM_POLICY_CREATE = 'create system policy';
const SYSTEM_POLICY_CREATE_OWN = 'create own system policy';
const SYSTEM_POLICY_VIEW = 'view system policy';
const SYSTEM_POLICY_VIEW_OWN = 'view own system policy';
const SYSTEM_POLICY_EDIT = 'edit system policy';
const SYSTEM_POLICY_EDIT_OWN = 'edit own system policy';
const SYSTEM_POLICY_DELETE = 'delete system policy';
const SYSTEM_POLICY_DELETE_OWN = 'delete own system policy';

/**
 * System third party permissions
 */
const SYSTEM_THIRD_PARTY_CREATE = 'create system third party';
const SYSTEM_THIRD_PARTY_CREATE_OWN = 'create own system third party';
const SYSTEM_THIRD_PARTY_VIEW = 'view system third party';
const SYSTEM_THIRD_PARTY_VIEW_OWN = 'view own system third party';
const SYSTEM_THIRD_PARTY_EDIT = 'edit system third party';
const SYSTEM_THIRD_PARTY_EDIT_OWN = 'edit own system third party';
const SYSTEM_THIRD_PARTY_DELETE = 'delete system third party';
const SYSTEM_THIRD_PARTY_DELETE_OWN = 'delete own system third party';
const SYSTEM_THIRD_PARTY_VALIDATE = 'validate system third party';
const SYSTEM_THIRD_PARTY_VALIDATE_OWN = 'validate own system third party';

/**
 * System access control permissions
 */
const SYSTEM_ACCESS_CONTROL_CREATE = 'create system access control';
const SYSTEM_ACCESS_CONTROL_CREATE_OWN = 'create own system access control';
const SYSTEM_ACCESS_CONTROL_VIEW = 'view system access control';
const SYSTEM_ACCESS_CONTROL_VIEW_OWN = 'view own system access control';
const SYSTEM_ACCESS_CONTROL_EDIT = 'edit system access control';
const SYSTEM_ACCESS_CONTROL_EDIT_OWN = 'edit own system access control';
const SYSTEM_ACCESS_CONTROL_DELETE = 'delete system access control';
const SYSTEM_ACCESS_CONTROL_DELETE_OWN = 'delete own system access control';
const SYSTEM_ACCESS_CONTROL_VALIDATE = 'validate system access control';
const SYSTEM_ACCESS_CONTROL_VALIDATE_OWN = 'validate own system access control';

/**
 * System data discovery permissions
 */
const SYSTEM_DATA_DISCOVERY_CREATE = 'create system data discovery';
const SYSTEM_DATA_DISCOVERY_CREATE_OWN = 'create own system data discovery';
const SYSTEM_DATA_DISCOVERY_VIEW = 'view system data discovery';
const SYSTEM_DATA_DISCOVERY_VIEW_OWN = 'view own system data discovery';
const SYSTEM_DATA_DISCOVERY_EDIT = 'edit system data discovery';
const SYSTEM_DATA_DISCOVERY_EDIT_OWN = 'edit own system data discovery';
const SYSTEM_DATA_DISCOVERY_DELETE = 'delete system data discovery';
const SYSTEM_DATA_DISCOVERY_DELETE_OWN = 'delete own system data discovery';
const SYSTEM_DATA_DISCOVERY_VALIDATE = 'validate system data discovery';
const SYSTEM_DATA_DISCOVERY_VALIDATE_OWN = 'validate own system data discovery';

/**
 * System log management permissions
 */
const SYSTEM_LOG_MANAGEMENT_CREATE = 'create system log management';
const SYSTEM_LOG_MANAGEMENT_CREATE_OWN = 'create own system log management';
const SYSTEM_LOG_MANAGEMENT_VIEW = 'view system log management';
const SYSTEM_LOG_MANAGEMENT_VIEW_OWN = 'view own system log management';
const SYSTEM_LOG_MANAGEMENT_EDIT = 'edit system log management';
const SYSTEM_LOG_MANAGEMENT_EDIT_OWN = 'edit own system log management';
const SYSTEM_LOG_MANAGEMENT_DELETE = 'delete system log management';
const SYSTEM_LOG_MANAGEMENT_DELETE_OWN = 'delete own system log management';
const SYSTEM_LOG_MANAGEMENT_VALIDATE = 'validate system log management';
const SYSTEM_LOG_MANAGEMENT_VALIDATE_OWN = 'validate own system log management';

/**
 * System network permissions
 */
const SYSTEM_NETWORK_CREATE = 'create system network';
const SYSTEM_NETWORK_CREATE_OWN = 'create own system network';
const SYSTEM_NETWORK_VIEW = 'view system network';
const SYSTEM_NETWORK_VIEW_OWN = 'view own system network';
const SYSTEM_NETWORK_EDIT = 'edit system network';
const SYSTEM_NETWORK_EDIT_OWN = 'edit own system network';
const SYSTEM_NETWORK_DELETE = 'delete system network';
const SYSTEM_NETWORK_DELETE_OWN = 'delete own system network';
const SYSTEM_NETWORK_VALIDATE = 'validate system network';
const SYSTEM_NETWORK_VALIDATE_OWN = 'validate own system network';

/**
 * System data object permissions
 */
const SYSTEM_DATA_OBJECT_CREATE = 'create system data object';
const SYSTEM_DATA_OBJECT_CREATE_OWN = 'create own system data object';
const SYSTEM_DATA_OBJECT_VIEW = 'view system data object';
const SYSTEM_DATA_OBJECT_VIEW_OWN = 'view own system data object';
const SYSTEM_DATA_OBJECT_EDIT = 'edit system data object';
const SYSTEM_DATA_OBJECT_EDIT_OWN = 'edit own system data object';
const SYSTEM_DATA_OBJECT_DELETE = 'delete system data object';
const SYSTEM_DATA_OBJECT_DELETE_OWN = 'delete own system data object';

/**
 * Activity permissions
 */
const ACTIVITY_CREATE = 'create activity';
const ACTIVITY_VIEW = 'view activity';
const ACTIVITY_VIEW_OWN = 'view own activity';
const ACTIVITY_EDIT = 'edit activity';
const ACTIVITY_EDIT_OWN = 'edit own activity';
const ACTIVITY_DELETE = 'delete activity';
const ACTIVITY_DELETE_OWN = 'delete own activity';

/**
 * Activity process permissions
 */
const ACTIVITY_PROCESS_CREATE = 'create activity process';
const ACTIVITY_PROCESS_CREATE_OWN = 'create own activity process';
const ACTIVITY_PROCESS_VIEW = 'view activity process';
const ACTIVITY_PROCESS_VIEW_OWN = 'view own activity process';
const ACTIVITY_PROCESS_EDIT = 'edit activity process';
const ACTIVITY_PROCESS_EDIT_OWN = 'edit own activity process';
const ACTIVITY_PROCESS_DELETE = 'delete activity process';
const ACTIVITY_PROCESS_DELETE_OWN = 'delete own activity process';

/**
 * Activity policy permissions
 */
const ACTIVITY_POLICY_CREATE = 'create activity policy';
const ACTIVITY_POLICY_CREATE_OWN = 'create own activity policy';
const ACTIVITY_POLICY_VIEW = 'view activity policy';
const ACTIVITY_POLICY_VIEW_OWN = 'view own activity policy';
const ACTIVITY_POLICY_EDIT = 'edit activity policy';
const ACTIVITY_POLICY_EDIT_OWN = 'edit own activity policy';
const ACTIVITY_POLICY_DELETE = 'delete activity policy';
const ACTIVITY_POLICY_DELETE_OWN = 'delete own activity policy';

/**
 * Activity system permissions
 */
const ACTIVITY_SYSTEM_CREATE = 'create activity system';
const ACTIVITY_SYSTEM_CREATE_OWN = 'create own activity system';
const ACTIVITY_SYSTEM_VIEW = 'view activity system';
const ACTIVITY_SYSTEM_VIEW_OWN = 'view own activity system';
const ACTIVITY_SYSTEM_EDIT = 'edit activity system';
const ACTIVITY_SYSTEM_EDIT_OWN = 'edit own activity system';
const ACTIVITY_SYSTEM_DELETE = 'delete activity system';
const ACTIVITY_SYSTEM_DELETE_OWN = 'delete own activity system';
const ACTIVITY_SYSTEM_VALIDATE = 'validate activity system';
const ACTIVITY_SYSTEM_VALIDATE_OWN = 'validate own activity system';

/**
 * Activity third party source permissions
 */
const ACTIVITY_THIRD_PARTY_SOURCE_CREATE = 'create activity third party source';
const ACTIVITY_THIRD_PARTY_SOURCE_CREATE_OWN = 'create own activity third party source';
const ACTIVITY_THIRD_PARTY_SOURCE_VIEW = 'view activity third party source';
const ACTIVITY_THIRD_PARTY_SOURCE_VIEW_OWN = 'view own activity third party source';
const ACTIVITY_THIRD_PARTY_SOURCE_EDIT = 'edit activity third party source';
const ACTIVITY_THIRD_PARTY_SOURCE_EDIT_OWN = 'edit own activity third party source';
const ACTIVITY_THIRD_PARTY_SOURCE_DELETE = 'delete activity third party source';
const ACTIVITY_THIRD_PARTY_SOURCE_DELETE_OWN = 'delete own activity third party source';
const ACTIVITY_THIRD_PARTY_SOURCE_VALIDATE = 'validate activity third party source';
const ACTIVITY_THIRD_PARTY_SOURCE_VALIDATE_OWN = 'validate own activity third party source';

/**
 * Activity third party receiver permissions
 */
const ACTIVITY_THIRD_PARTY_RECEIVER_CREATE = 'create activity third party receiver';
const ACTIVITY_THIRD_PARTY_RECEIVER_CREATE_OWN = 'create own activity third party receiver';
const ACTIVITY_THIRD_PARTY_RECEIVER_VIEW = 'view activity third party receiver';
const ACTIVITY_THIRD_PARTY_RECEIVER_VIEW_OWN = 'view own activity third party receiver';
const ACTIVITY_THIRD_PARTY_RECEIVER_EDIT = 'edit activity third party receiver';
const ACTIVITY_THIRD_PARTY_RECEIVER_EDIT_OWN = 'edit own activity third party receiver';
const ACTIVITY_THIRD_PARTY_RECEIVER_DELETE = 'delete activity third party receiver';
const ACTIVITY_THIRD_PARTY_RECEIVER_DELETE_OWN = 'delete own activity third party receiver';
const ACTIVITY_THIRD_PARTY_RECEIVER_VALIDATE = 'validate activity third party receiver';
const ACTIVITY_THIRD_PARTY_RECEIVER_VALIDATE_OWN = 'validate own activity third party receiver';

/**
 * Activity data subject permissions
 */
const ACTIVITY_DATA_SUBJECT_CREATE = 'create activity data subject';
const ACTIVITY_DATA_SUBJECT_CREATE_OWN = 'create own activity data subject';
const ACTIVITY_DATA_SUBJECT_VIEW = 'view activity data subject';
const ACTIVITY_DATA_SUBJECT_VIEW_OWN = 'view own activity data subject';
const ACTIVITY_DATA_SUBJECT_EDIT = 'edit activity data subject';
const ACTIVITY_DATA_SUBJECT_EDIT_OWN = 'edit own activity data subject';
const ACTIVITY_DATA_SUBJECT_DELETE = 'delete activity data subject';
const ACTIVITY_DATA_SUBJECT_DELETE_OWN = 'delete own activity data subject';

/**
 * Activity retention rule permissions
 */
const ACTIVITY_RETENTION_RULE_CREATE = 'create activity retention rule';
const ACTIVITY_RETENTION_RULE_CREATE_OWN = 'create own activity retention rule';
const ACTIVITY_RETENTION_RULE_VIEW = 'view activity retention rule';
const ACTIVITY_RETENTION_RULE_VIEW_OWN = 'view own activity retention rule';
const ACTIVITY_RETENTION_RULE_EDIT = 'edit activity retention rule';
const ACTIVITY_RETENTION_RULE_EDIT_OWN = 'edit own activity retention rule';
const ACTIVITY_RETENTION_RULE_DELETE = 'delete activity retention rule';
const ACTIVITY_RETENTION_RULE_DELETE_OWN = 'delete own activity retention rule';
const ACTIVITY_RETENTION_RULE_VALIDATE = 'validate activity retention rule';
const ACTIVITY_RETENTION_RULE_VALIDATE_OWN = 'validate own activity retention rule';

/**
 * Activity integrity permissions
 */
const ACTIVITY_INTEGRITY_CREATE = 'create activity integrity';
const ACTIVITY_INTEGRITY_VIEW = 'view activity integrity';
const ACTIVITY_INTEGRITY_VIEW_OWN = 'view own activity integrity';
const ACTIVITY_INTEGRITY_EDIT = 'edit activity integrity';
const ACTIVITY_INTEGRITY_EDIT_OWN = 'edit own activity integrity';
const ACTIVITY_INTEGRITY_DELETE = 'delete activity integrity';
const ACTIVITY_INTEGRITY_DELETE_OWN = 'delete own activity integrity';
const ACTIVITY_INTEGRITY_VALIDATE = 'validate activity integrity';
const ACTIVITY_INTEGRITY_VALIDATE_OWN = 'validate own activity integrity';

/**
 * Activity principles of proportionality permissions
 */
const ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_CREATE = 'create activity principle of proportionality';
const ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VIEW = 'view activity principle of proportionality';
const ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VIEW_OWN = 'view own activity principle of proportionality';
const ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_EDIT = 'edit activity principle of proportionality';
const ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_EDIT_OWN = 'edit own activity principle of proportionality';
const ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_DELETE = 'delete activity principle of proportionality';
const ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_DELETE_OWN = 'delete own activity principle of proportionality';
const ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VALIDATE = 'validate activity principle of proportionality';
const ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VALIDATE_OWN = 'validate activity principle of proportionality';

/**
 * Activity processing type permissions
 */
const ACTIVITY_PROCESSING_TYPE_CREATE = 'create activity processing type';
const ACTIVITY_PROCESSING_TYPE_VIEW = 'view activity processing type';
const ACTIVITY_PROCESSING_TYPE_VIEW_OWN = 'view own activity processing type';
const ACTIVITY_PROCESSING_TYPE_EDIT = 'edit activity processing type';
const ACTIVITY_PROCESSING_TYPE_EDIT_OWN = 'edit own activity processing type';
const ACTIVITY_PROCESSING_TYPE_DELETE = 'delete activity processing type';
const ACTIVITY_PROCESSING_TYPE_DELETE_OWN = 'delete own activity processing type';
const ACTIVITY_PROCESSING_TYPE_VALIDATE = 'validate activity processing type';
const ACTIVITY_PROCESSING_TYPE_VALIDATE_OWN = 'validate own activity processing type';

/**
 * Activity organizations permissions
 */
const ACTIVITY_ORGANIZATION_CREATE = 'create activity organization';
const ACTIVITY_ORGANIZATION_CREATE_OWN = 'create own activity organization';
const ACTIVITY_ORGANIZATION_VIEW = 'view activity organization';
const ACTIVITY_ORGANIZATION_VIEW_OWN = 'view own activity organization';
const ACTIVITY_ORGANIZATION_EDIT = 'edit activity organization';
const ACTIVITY_ORGANIZATION_EDIT_OWN = 'edit own activity organization';
const ACTIVITY_ORGANIZATION_DELETE = 'delete activity organization';
const ACTIVITY_ORGANIZATION_DELETE_OWN = 'delete own activity organization';

/**
 * Activity integrity controls permissions
 */
const ACTIVITY_INTEGRITY_CONTROL_CREATE = 'create activity integrity control';
const ACTIVITY_INTEGRITY_CONTROL_CREATE_OWN = 'create own activity integrity control';
const ACTIVITY_INTEGRITY_CONTROL_VIEW = 'view activity integrity control';
const ACTIVITY_INTEGRITY_CONTROL_VIEW_OWN = 'view own activity integrity control';
const ACTIVITY_INTEGRITY_CONTROL_EDIT = 'edit activity integrity control';
const ACTIVITY_INTEGRITY_CONTROL_EDIT_OWN = 'edit own activity integrity control';
const ACTIVITY_INTEGRITY_CONTROL_DELETE = 'delete activity integrity control';
const ACTIVITY_INTEGRITY_CONTROL_DELETE_OWN = 'delete own activity integrity control';

/**
 * Activity risk scenario permissions
 */
const ACTIVITY_RISK_SCENARIO_CREATE = 'create activity risk scenario';
const ACTIVITY_RISK_SCENARIO_CREATE_OWN = 'create own activity risk scenario';
const ACTIVITY_RISK_SCENARIO_VIEW = 'view activity risk scenario';
const ACTIVITY_RISK_SCENARIO_VIEW_OWN = 'view own activity risk scenario';
const ACTIVITY_RISK_SCENARIO_EDIT = 'edit activity risk scenario';
const ACTIVITY_RISK_SCENARIO_EDIT_OWN = 'edit own activity risk scenario';
const ACTIVITY_RISK_SCENARIO_DELETE = 'delete activity risk scenario';
const ACTIVITY_RISK_SCENARIO_DELETE_OWN = 'delete own activity risk scenario';
const ACTIVITY_RISK_SCENARIO_VALIDATE = 'validate activity risk scenario';
const ACTIVITY_RISK_SCENARIO_VALIDATE_OWN = 'validate own activity risk scenario';

/**
 * Campaign template permissions
 */
const CAMPAIGN_TEMPLATE_CREATE = 'create campaign template';
const CAMPAIGN_TEMPLATE_VIEW = 'view campaign template';
const CAMPAIGN_TEMPLATE_VIEW_OWN = 'view own campaign template';
const CAMPAIGN_TEMPLATE_EDIT = 'edit campaign template';
const CAMPAIGN_TEMPLATE_EDIT_OWN = 'edit own campaign template';
const CAMPAIGN_TEMPLATE_DELETE = 'delete campaign template';
const CAMPAIGN_TEMPLATE_DELETE_OWN = 'delete own campaign template';

/**
 * Campaign permissions
 */
const CAMPAIGN_CREATE = 'create campaign';
const CAMPAIGN_CREATE_OWN = 'create own campaign';
const CAMPAIGN_VIEW = 'view campaign';
const CAMPAIGN_VIEW_OWN = 'view own campaign';
const CAMPAIGN_EDIT = 'edit campaign';
const CAMPAIGN_EDIT_OWN = 'edit own campaign';
const CAMPAIGN_DELETE = 'delete campaign';
const CAMPAIGN_DELETE_OWN = 'delete own campaign';

/**
 * Project permissions
 */
const PROJECT_CREATE = 'create project';
const PROJECT_CREATE_OWN = 'create own project';
const PROJECT_VIEW = 'view project';
const PROJECT_VIEW_OWN = 'view own project';
const PROJECT_EDIT = 'edit project';
const PROJECT_EDIT_OWN = 'edit own project';
const PROJECT_DELETE = 'delete project';
const PROJECT_DELETE_OWN = 'delete own project';

/**
 * Guide permissions
 */
const GUIDE_CREATE = 'create guide';
const GUIDE_VIEW = 'view guide';
const GUIDE_VIEW_OWN = 'view own guide';
const GUIDE_EDIT = 'edit guide';
const GUIDE_EDIT_OWN = 'edit own guide';
const GUIDE_DELETE = 'delete guide';
const GUIDE_DELETE_OWN = 'delete own guide';


/**
 * Actors permissions
 */
const ACTOR_CREATE = 'create actor';
const ACTOR_VIEW = 'view actor';
const ACTOR_VIEW_OWN = 'view own actor';
const ACTOR_EDIT = 'edit actor';
const ACTOR_EDIT_OWN = 'edit own actor';
const ACTOR_DELETE = 'delete actor';
const ACTOR_DELETE_OWN = 'delete own actor';

/**
 * Threats permissions
 */
const THREAT_CREATE = 'create threat';
const THREAT_VIEW = 'view threat';
const THREAT_VIEW_OWN = 'view own threat';
const THREAT_EDIT = 'edit threat';
const THREAT_EDIT_OWN = 'edit own threat';
const THREAT_DELETE = 'delete threat';
const THREAT_DELETE_OWN = 'delete own threat';

/**
 * Vulnerabilities permissions
 */
const VULNERABILITY_CREATE = 'create vulnerability';
const VULNERABILITY_VIEW = 'view vulnerability';
const VULNERABILITY_VIEW_OWN = 'view own vulnerability';
const VULNERABILITY_EDIT = 'edit vulnerability';
const VULNERABILITY_EDIT_OWN = 'edit own vulnerability';
const VULNERABILITY_DELETE = 'delete vulnerability';
const VULNERABILITY_DELETE_OWN = 'delete own vulnerability';

/**
 * Framework permissions
 */
const FRAMEWORK_CREATE = 'create framework';
const FRAMEWORK_VIEW = 'view framework';
const FRAMEWORK_VIEW_OWN = 'view own framework';
const FRAMEWORK_EDIT = 'edit framework';
const FRAMEWORK_EDIT_OWN = 'edit own framework';
const FRAMEWORK_DELETE = 'delete framework';
const FRAMEWORK_DELETE_OWN = 'delete own framework';

/**
 * Control objective permissions
 */
const CONTROL_OBJECTIVE_CREATE = 'create control objective';
const CONTROL_OBJECTIVE_VIEW = 'view control objective';
const CONTROL_OBJECTIVE_VIEW_OWN = 'view own control objective';
const CONTROL_OBJECTIVE_EDIT = 'edit control objective';
const CONTROL_OBJECTIVE_EDIT_OWN = 'edit own control objective';
const CONTROL_OBJECTIVE_DELETE = 'delete control objective';
const CONTROL_OBJECTIVE_DELETE_OWN = 'delete own control objective';

/**
 * Assessment permissions
 */
const ASSESSMENT_CREATE = 'create assessment';
const ASSESSMENT_VIEW = 'view assessment';
const ASSESSMENT_VIEW_OWN = 'view own assessment';
const ASSESSMENT_EDIT = 'edit assessment';
const ASSESSMENT_EDIT_OWN = 'edit own assessment';
const ASSESSMENT_DELETE = 'delete assessment';
const ASSESSMENT_DELETE_OWN = 'delete own assessment';

/**
 * Framework control permissions
 */
const FRAMEWORK_CONTROL_CREATE = 'create framework control';
const FRAMEWORK_CONTROL_VIEW = 'view framework control';
const FRAMEWORK_CONTROL_VIEW_OWN = 'view own framework control';
const FRAMEWORK_CONTROL_EDIT = 'edit framework control';
const FRAMEWORK_CONTROL_EDIT_OWN = 'edit own framework control';
const FRAMEWORK_CONTROL_DELETE = 'delete framework control';
const FRAMEWORK_CONTROL_DELETE_OWN = 'delete own framework control';

/**
 * Risk scenario permissions
 */
const RISK_SCENARIO_CREATE = 'create risk scenario';
const RISK_SCENARIO_VIEW = 'view risk scenario';
const RISK_SCENARIO_VIEW_OWN = 'view own risk scenario';
const RISK_SCENARIO_EDIT = 'edit risk scenario';
const RISK_SCENARIO_EDIT_OWN = 'edit own risk scenario';
const RISK_SCENARIO_DELETE = 'delete risk scenario';
const RISK_SCENARIO_DELETE_OWN = 'delete own risk scenario';
const RISK_SCENARIO_VALIDATE = 'validate risk scenario';
const RISK_SCENARIO_VALIDATE_OWN = 'validate own risk scenario';

/**
 * Risk scenarion threat permissions
 */
const RISK_SCENARIO_THREAT_CREATE = 'create risk scenario threat';
const RISK_SCENARIO_THREAT_CREATE_OWN = 'create own risk scenario threat';
const RISK_SCENARIO_THREAT_VIEW = 'view risk scenario threat';
const RISK_SCENARIO_THREAT_VIEW_OWN = 'view own risk scenario threat';
const RISK_SCENARIO_THREAT_EDIT = 'edit risk scenario threat';
const RISK_SCENARIO_THREAT_EDIT_OWN = 'edit own risk scenario threat';
const RISK_SCENARIO_THREAT_DELETE = 'delete risk scenario threat';
const RISK_SCENARIO_THREAT_DELETE_OWN = 'delete own risk scenario threat';
const RISK_SCENARIO_THREAT_VALIDATE = 'validate risk scenario threat';
const RISK_SCENARIO_THREAT_VALIDATE_OWN = 'validate own risk scenario threat';

/**
 * Risk scenario vulnerability permissions
 */
const RISK_SCENARIO_VULNERABILITY_CREATE = 'create risk scenario vulnerability';
const RISK_SCENARIO_VULNERABILITY_CREATE_OWN = 'create own risk scenario vulnerability';
const RISK_SCENARIO_VULNERABILITY_VIEW = 'view risk scenario vulnerability';
const RISK_SCENARIO_VULNERABILITY_VIEW_OWN = 'view own risk scenario vulnerability';
const RISK_SCENARIO_VULNERABILITY_EDIT = 'edit risk scenario vulnerability';
const RISK_SCENARIO_VULNERABILITY_EDIT_OWN = 'edit own risk scenario vulnerability';
const RISK_SCENARIO_VULNERABILITY_DELETE = 'delete risk scenario vulnerability';
const RISK_SCENARIO_VULNERABILITY_DELETE_OWN = 'delete own risk scenario vulnerability';
const RISK_SCENARIO_VULNERABILITY_VALIDATE = 'validate risk scenario vulnerability';
const RISK_SCENARIO_VULNERABILITY_VALIDATE_OWN = 'validate own risk scenario vulnerability';


/**
 * Generic control permissions
 */
const GENERIC_CONTROL_CREATE = 'create generic control';
const GENERIC_CONTROL_VIEW = 'view generic control';
const GENERIC_CONTROL_VIEW_OWN = 'view own generic control';
const GENERIC_CONTROL_EDIT = 'edit generic control';
const GENERIC_CONTROL_EDIT_OWN = 'edit own generic control';
const GENERIC_CONTROL_DELETE = 'delete generic control';
const GENERIC_CONTROL_DELETE_OWN = 'delete own generic control';
const GENERIC_CONTROL_VALIDATE = 'validate generic control';
const GENERIC_CONTROL_VALIDATE_OWN = 'validate own generic control';

/**
 * Generic control policy permissions
 */
const GENERIC_CONTROL_POLICY_CREATE = 'create generic control policy';
const GENERIC_CONTROL_POLICY_CREATE_OWN = 'create own generic control policy';
const GENERIC_CONTROL_POLICY_VIEW = 'view generic control policy';
const GENERIC_CONTROL_POLICY_VIEW_OWN = 'view own generic control policy';
const GENERIC_CONTROL_POLICY_EDIT = 'edit generic control policy';
const GENERIC_CONTROL_POLICY_EDIT_OWN = 'edit own generic control policy';
const GENERIC_CONTROL_POLICY_DELETE = 'delete generic control policy';
const GENERIC_CONTROL_POLICY_DELETE_OWN = 'delete own generic control policy';

/**
 * Generic control framework permissions
 */
const GENERIC_CONTROL_FRAMEWORK_CREATE = 'create generic control framework';
const GENERIC_CONTROL_FRAMEWORK_CREATE_OWN = 'create own generic control framework';
const GENERIC_CONTROL_FRAMEWORK_VIEW = 'view generic control framework';
const GENERIC_CONTROL_FRAMEWORK_VIEW_OWN = 'view own generic control framework';
const GENERIC_CONTROL_FRAMEWORK_EDIT = 'edit generic control framework';
const GENERIC_CONTROL_FRAMEWORK_EDIT_OWN = 'edit own generic control framework';
const GENERIC_CONTROL_FRAMEWORK_DELETE = 'delete generic control framework';
const GENERIC_CONTROL_FRAMEWORK_DELETE_OWN = 'delete own generic control framework';

/**
 * Generic control risk scenario permissions
 */
const GENERIC_CONTROL_RISK_SCENARIO_CREATE = 'create generic control risk scenario';
const GENERIC_CONTROL_RISK_SCENARIO_CREATE_OWN = 'create own generic control risk scenario';
const GENERIC_CONTROL_RISK_SCENARIO_VIEW = 'view generic control risk scenario';
const GENERIC_CONTROL_RISK_SCENARIO_VIEW_OWN = 'view own generic control risk scenario';
const GENERIC_CONTROL_RISK_SCENARIO_EDIT = 'edit generic control risk scenario';
const GENERIC_CONTROL_RISK_SCENARIO_EDIT_OWN = 'edit own generic control risk scenario';
const GENERIC_CONTROL_RISK_SCENARIO_DELETE = 'delete generic control risk scenario';
const GENERIC_CONTROL_RISK_SCENARIO_DELETE_OWN = 'delete own generic control risk scenario';

/**
 * Generic control threat permissions
 */
const GENERIC_CONTROL_THREAT_CREATE = 'create generic control threat';
const GENERIC_CONTROL_THREAT_CREATE_OWN = 'create own generic control threat';
const GENERIC_CONTROL_THREAT_VIEW = 'view generic control threat';
const GENERIC_CONTROL_THREAT_VIEW_OWN = 'view own generic control threat';
const GENERIC_CONTROL_THREAT_EDIT = 'edit generic control threat';
const GENERIC_CONTROL_THREAT_EDIT_OWN = 'edit own generic control threat';
const GENERIC_CONTROL_THREAT_DELETE = 'delete generic control threat';
const GENERIC_CONTROL_THREAT_DELETE_OWN = 'delete own generic control threat';

/**
 * Generic control vulnerability permissions
 */
const GENERIC_CONTROL_VULNERABILITY_CREATE = 'create generic control vulnerability';
const GENERIC_CONTROL_VULNERABILITY_CREATE_OWN = 'create own generic control vulnerability';
const GENERIC_CONTROL_VULNERABILITY_VIEW = 'view generic control vulnerability';
const GENERIC_CONTROL_VULNERABILITY_VIEW_OWN = 'view own generic control vulnerability';
const GENERIC_CONTROL_VULNERABILITY_EDIT = 'edit generic control vulnerability';
const GENERIC_CONTROL_VULNERABILITY_EDIT_OWN = 'edit own generic control vulnerability';
const GENERIC_CONTROL_VULNERABILITY_DELETE = 'delete generic control vulnerability';
const GENERIC_CONTROL_VULNERABILITY_DELETE_OWN = 'delete own generic control vulnerability';


/**
 * System risk scenario permissions
 */
const SYSTEM_RISK_SCENARIO_CREATE = 'create system risk scenario';
const SYSTEM_RISK_SCENARIO_CREATE_OWN = 'create own system risk scenario';
const SYSTEM_RISK_SCENARIO_VIEW = 'view system risk scenario';
const SYSTEM_RISK_SCENARIO_VIEW_OWN = 'view own system risk scenario';
const SYSTEM_RISK_SCENARIO_EDIT = 'edit system risk scenario';
const SYSTEM_RISK_SCENARIO_EDIT_OWN = 'edit own system risk scenario';
const SYSTEM_RISK_SCENARIO_DELETE = 'delete system risk scenario';
const SYSTEM_RISK_SCENARIO_DELETE_OWN = 'delete own system risk scenario';
const SYSTEM_RISK_SCENARIO_VALIDATE = 'validate system risk scenario';
const SYSTEM_RISK_SCENARIO_VALIDATE_OWN = 'validate own system risk scenario';


/**
 * Process risk scenario permissions
 */
const PROCESS_RISK_SCENARIO_CREATE = 'create process risk scenario';
const PROCESS_RISK_SCENARIO_CREATE_OWN = 'create own process risk scenario';
const PROCESS_RISK_SCENARIO_VIEW = 'view process risk scenario';
const PROCESS_RISK_SCENARIO_VIEW_OWN = 'view own process risk scenario';
const PROCESS_RISK_SCENARIO_EDIT = 'edit process risk scenario';
const PROCESS_RISK_SCENARIO_EDIT_OWN = 'edit own process risk scenario';
const PROCESS_RISK_SCENARIO_DELETE = 'delete process risk scenario';
const PROCESS_RISK_SCENARIO_DELETE_OWN = 'delete own process risk scenario';
const PROCESS_RISK_SCENARIO_VALIDATE = 'validate process risk scenario';
const PROCESS_RISK_SCENARIO_VALIDATE_OWN = 'validate own process risk scenario';

/**
 * Third party risk scenario permissions
 */
const THIRD_PARTY_RISK_SCENARIO_CREATE = 'create third party risk scenario';
const THIRD_PARTY_RISK_SCENARIO_CREATE_OWN = 'create own third party risk scenario';
const THIRD_PARTY_RISK_SCENARIO_VIEW = 'view third party risk scenario';
const THIRD_PARTY_RISK_SCENARIO_VIEW_OWN = 'view own third party risk scenario';
const THIRD_PARTY_RISK_SCENARIO_EDIT = 'edit third party risk scenario';
const THIRD_PARTY_RISK_SCENARIO_EDIT_OWN = 'edit own third party risk scenario';
const THIRD_PARTY_RISK_SCENARIO_DELETE = 'delete third party risk scenario';
const THIRD_PARTY_RISK_SCENARIO_DELETE_OWN = 'delete own third party risk scenario';
const THIRD_PARTY_RISK_SCENARIO_VALIDATE = 'validate third party risk scenario';
const THIRD_PARTY_RISK_SCENARIO_VALIDATE_OWN = 'validate own third party risk scenario';

/**
 * Third party document permissions
 */
const THIRD_PARTY_DOCUMENT_CREATE = 'create third party document';
const THIRD_PARTY_DOCUMENT_CREATE_OWN = 'create own third party document';
const THIRD_PARTY_DOCUMENT_VIEW = 'view third party document';
const THIRD_PARTY_DOCUMENT_VIEW_OWN = 'view own third party document';
const THIRD_PARTY_DOCUMENT_EDIT = 'edit third party document';
const THIRD_PARTY_DOCUMENT_EDIT_OWN = 'edit own third party document';
const THIRD_PARTY_DOCUMENT_DELETE = 'delete third party document';
const THIRD_PARTY_DOCUMENT_DELETE_OWN = 'delete own third party document';
const THIRD_PARTY_DOCUMENT_VALIDATE = 'validate third party document';
const THIRD_PARTY_DOCUMENT_VALIDATE_OWN = 'validate own third party document';

/**
 * Third party document permissions
 */
const POLICY_DOCUMENT_CREATE = 'create third party document';
const POLICY_DOCUMENT_CREATE_OWN = 'create own third party document';
const POLICY_DOCUMENT_VIEW = 'view third party document';
const POLICY_DOCUMENT_VIEW_OWN = 'view own third party document';
const POLICY_DOCUMENT_EDIT = 'edit third party document';
const POLICY_DOCUMENT_EDIT_OWN = 'edit own third party document';
const POLICY_DOCUMENT_DELETE = 'delete third party document';
const POLICY_DOCUMENT_DELETE_OWN = 'delete own third party document';
const POLICY_DOCUMENT_VALIDATE = 'validate third party document';
const POLICY_DOCUMENT_VALIDATE_OWN = 'validate own third party document';

export default {

  ROLE_SUPER_ADMIN: ROLE_SUPER_ADMIN,
  ROLE_CLIENT_ADMIN: ROLE_CLIENT_ADMIN,
  ROLE_PARTITION_ADMIN: ROLE_PARTITION_ADMIN,
  ROLE_VALIDATOR: ROLE_VALIDATOR,
  ROLE_MEMBER: ROLE_MEMBER,

  /**
   * Default model permission
   */
  MODEL_VIEW: MODEL_VIEW,
  MODEL_EDIT: MODEL_EDIT,
  MODEL_DELETE: MODEL_DELETE,
  MODEL_VIEW_POLICY: MODEL_VIEW_POLICY,
  MODEL_VIEW_DATA_SUBJECT: MODEL_VIEW_DATA_SUBJECT,
  MODEL_VIEW_RETENTION_RULE: MODEL_VIEW_RETENTION_RULE,
  MODEL_VIEW_ORGANIZATION: MODEL_VIEW_ORGANIZATION,
  MODEL_VIEW_INTEGRITY_CONTROL: MODEL_VIEW_INTEGRITY_CONTROL,
  MODEL_VIEW_SYSTEM: MODEL_VIEW_SYSTEM,
  MODEL_VIEW_THIRD_PARTY_SOURCE: MODEL_VIEW_THIRD_PARTY_SOURCE,
  MODEL_VIEW_THIRD_PARTY_RECEIVER: MODEL_VIEW_THIRD_PARTY_RECEIVER,
  MODEL_VIEW_LEGAL_BASIS: MODEL_VIEW_LEGAL_BASIS,
  MODEL_VIEW_INFORMATION_OBLIGATION: MODEL_VIEW_INFORMATION_OBLIGATION,
  MODEL_VIEW_CONFIDENTIALITY: MODEL_VIEW_CONFIDENTIALITY,
  MODEL_VIEW_INTEGRITY: MODEL_VIEW_INTEGRITY,
  MODEL_VIEW_AVAILABILITY: MODEL_VIEW_AVAILABILITY,
  MODEL_VIEW_DATA_OBJECT: MODEL_VIEW_DATA_OBJECT,
  MODEL_VIEW_THIRD_PARTY: MODEL_VIEW_THIRD_PARTY,
  MODEL_VIEW_ACCESS_CONTROL: MODEL_VIEW_ACCESS_CONTROL,
  MODEL_VIEW_LOG_MANAGEMENT: MODEL_VIEW_LOG_MANAGEMENT,
  MODEL_VIEW_NETWORK: MODEL_VIEW_NETWORK,
  MODEL_VIEW_DATA_DISCOVERY: MODEL_VIEW_DATA_DISCOVERY,
  MODEL_VIEW_PRINCIPLES_OF_PROPORTIONALITY: MODEL_VIEW_PRINCIPLES_OF_PROPORTIONALITY,
  MODEL_VIEW_PROCESSING_TYPE: MODEL_VIEW_PROCESSING_TYPE,

  // Maintenance permissions
  MAINTENANCE_VIEW: MAINTENANCE_VIEW,

  // User permissions
  USER_CREATE: USER_CREATE,
  USER_VIEW: USER_VIEW,
  USER_VIEW_OWN: USER_VIEW_OWN,
  USER_EDIT: USER_EDIT,
  USER_EDIT_OWN: USER_EDIT_OWN,
  USER_DELETE: USER_DELETE,
  USER_DELETE_OWN: USER_DELETE_OWN,

  // Client permissions
  CLIENT_CREATE: CLIENT_CREATE,
  CLIENT_VIEW: CLIENT_VIEW,
  CLIENT_VIEW_OWN: CLIENT_VIEW_OWN,
  CLIENT_EDIT: CLIENT_EDIT,
  CLIENT_EDIT_OWN: CLIENT_EDIT_OWN,
  CLIENT_DELETE: CLIENT_DELETE,
  CLIENT_DELETE_OWN: CLIENT_DELETE_OWN,
  CLIENT_ADD_USER: CLIENT_ADD_USER,
  CLIENT_REMOVE_USER: CLIENT_REMOVE_USER,

  /**
   * Partition permissions
   */
  PARTITION_CREATE:PARTITION_CREATE,
  PARTITION_VIEW:PARTITION_VIEW,
  PARTITION_VIEW_OWN:PARTITION_VIEW_OWN,
  PARTITION_EDIT:PARTITION_EDIT,
  PARTITION_EDIT_OWN:PARTITION_EDIT_OWN,
  PARTITION_DELETE:PARTITION_DELETE,
  PARTITION_DELETE_OWN:PARTITION_DELETE_OWN,
  PARTITION_ADD_USER:PARTITION_ADD_USER,
  PARTITION_REMOVE_USER:PARTITION_REMOVE_USER,

  // Third party permissions
  THIRD_PARTY_CREATE: THIRD_PARTY_CREATE,
  THIRD_PARTY_VIEW: THIRD_PARTY_VIEW,
  THIRD_PARTY_VIEW_OWN: THIRD_PARTY_VIEW_OWN,
  THIRD_PARTY_EDIT: THIRD_PARTY_EDIT,
  THIRD_PARTY_EDIT_OWN: THIRD_PARTY_EDIT_OWN,
  THIRD_PARTY_DELETE: THIRD_PARTY_DELETE,
  THIRD_PARTY_DELETE_OWN: THIRD_PARTY_DELETE_OWN,
  THIRD_PARTY_VALIDATE: THIRD_PARTY_VALIDATE,
  THIRD_PARTY_VALIDATE_OWN: THIRD_PARTY_VALIDATE_OWN,

  //Policy permissions
  POLICY_CREATE: POLICY_CREATE,
  POLICY_VIEW: POLICY_VIEW,
  POLICY_VIEW_OWN: POLICY_VIEW_OWN,
  POLICY_EDIT: POLICY_EDIT,
  POLICY_EDIT_OWN: POLICY_EDIT_OWN,
  POLICY_DELETE: POLICY_DELETE,
  POLICY_DELETE_OWN: POLICY_DELETE_OWN,
  POLICY_VALIDATE: POLICY_VALIDATE,
  POLICY_VALIDATE_OWN: POLICY_VALIDATE_OWN,

  //Measure permissions
  MEASURE_CREATE: MEASURE_CREATE,
  MEASURE_VIEW: MEASURE_VIEW,
  MEASURE_VIEW_OWN: MEASURE_VIEW_OWN,
  MEASURE_EDIT: MEASURE_EDIT,
  MEASURE_EDIT_OWN: MEASURE_EDIT_OWN,
  MEASURE_DELETE: MEASURE_DELETE,
  MEASURE_DELETE_OWN: MEASURE_DELETE_OWN,

  //Measure category permissions
  MEASURE_CATEGORY_CREATE: MEASURE_CATEGORY_CREATE,
  MEASURE_CATEGORY_VIEW: MEASURE_CATEGORY_VIEW,
  MEASURE_CATEGORY_VIEW_OWN: MEASURE_CATEGORY_VIEW_OWN,
  MEASURE_CATEGORY_EDIT: MEASURE_CATEGORY_EDIT,
  MEASURE_CATEGORY_EDIT_OWN: MEASURE_CATEGORY_EDIT_OWN,
  MEASURE_CATEGORY_DELETE: MEASURE_CATEGORY_DELETE,
  MEASURE_CATEGORY_DELETE_OWN: MEASURE_CATEGORY_DELETE_OWN,

  //Incident category permissions
  INCIDENT_CATEGORY_CREATE: INCIDENT_CATEGORY_CREATE,
  INCIDENT_CATEGORY_VIEW: INCIDENT_CATEGORY_VIEW,
  INCIDENT_CATEGORY_VIEW_OWN: INCIDENT_CATEGORY_VIEW_OWN,
  INCIDENT_CATEGORY_EDIT: INCIDENT_CATEGORY_EDIT,
  INCIDENT_CATEGORY_EDIT_OWN: INCIDENT_CATEGORY_EDIT_OWN,
  INCIDENT_CATEGORY_DELETE: INCIDENT_CATEGORY_DELETE,
  INCIDENT_CATEGORY_DELETE_OWN: INCIDENT_CATEGORY_DELETE_OWN,

  //Incident category question permissions
  INCIDENT_CATEGORY_QUESTION_CREATE: INCIDENT_CATEGORY_QUESTION_CREATE,
  INCIDENT_CATEGORY_QUESTION_VIEW: INCIDENT_CATEGORY_QUESTION_VIEW,
  INCIDENT_CATEGORY_QUESTION_VIEW_OWN: INCIDENT_CATEGORY_QUESTION_VIEW_OWN,
  INCIDENT_CATEGORY_QUESTION_EDIT: INCIDENT_CATEGORY_QUESTION_EDIT,
  INCIDENT_CATEGORY_QUESTION_EDIT_OWN: INCIDENT_CATEGORY_QUESTION_EDIT_OWN,
  INCIDENT_CATEGORY_QUESTION_DELETE: INCIDENT_CATEGORY_QUESTION_DELETE,
  INCIDENT_CATEGORY_QUESTION_DELETE_OWN: INCIDENT_CATEGORY_QUESTION_DELETE_OWN,

  //Incident category system permissions
  INCIDENT_CATEGORY_SYSTEM_CREATE: INCIDENT_CATEGORY_SYSTEM_CREATE,
  INCIDENT_CATEGORY_SYSTEM_CREATE_OWN: INCIDENT_CATEGORY_SYSTEM_CREATE_OWN,
  INCIDENT_CATEGORY_SYSTEM_VIEW: INCIDENT_CATEGORY_SYSTEM_VIEW,
  INCIDENT_CATEGORY_SYSTEM_VIEW_OWN: INCIDENT_CATEGORY_SYSTEM_VIEW_OWN,
  INCIDENT_CATEGORY_SYSTEM_EDIT: INCIDENT_CATEGORY_SYSTEM_EDIT,
  INCIDENT_CATEGORY_SYSTEM_EDIT_OWN: INCIDENT_CATEGORY_SYSTEM_EDIT_OWN,
  INCIDENT_CATEGORY_SYSTEM_DELETE: INCIDENT_CATEGORY_SYSTEM_DELETE,
  INCIDENT_CATEGORY_SYSTEM_DELETE_OWN: INCIDENT_CATEGORY_SYSTEM_DELETE_OWN,

  //Incident category risk scenario permissions
  INCIDENT_CATEGORY_RISK_SCENARIO_CREATE: INCIDENT_CATEGORY_RISK_SCENARIO_CREATE,
  INCIDENT_CATEGORY_RISK_SCENARIO_CREATE_OWN: INCIDENT_CATEGORY_RISK_SCENARIO_CREATE_OWN,
  INCIDENT_CATEGORY_RISK_SCENARIO_VIEW: INCIDENT_CATEGORY_RISK_SCENARIO_VIEW,
  INCIDENT_CATEGORY_RISK_SCENARIO_VIEW_OWN: INCIDENT_CATEGORY_RISK_SCENARIO_VIEW_OWN,
  INCIDENT_CATEGORY_RISK_SCENARIO_EDIT: INCIDENT_CATEGORY_RISK_SCENARIO_EDIT,
  INCIDENT_CATEGORY_RISK_SCENARIO_EDIT_OWN: INCIDENT_CATEGORY_RISK_SCENARIO_EDIT_OWN,
  INCIDENT_CATEGORY_RISK_SCENARIO_DELETE: INCIDENT_CATEGORY_RISK_SCENARIO_DELETE,
  INCIDENT_CATEGORY_RISK_SCENARIO_DELETE_OWN: INCIDENT_CATEGORY_RISK_SCENARIO_DELETE_OWN,

  /**
   * Activity measure permissions
   */
  ACTIVITY_MEASURE_CREATE: ACTIVITY_MEASURE_CREATE,
  ACTIVITY_MEASURE_CREATE_OWN: ACTIVITY_MEASURE_CREATE_OWN,
  ACTIVITY_MEASURE_VIEW: ACTIVITY_MEASURE_VIEW,
  ACTIVITY_MEASURE_VIEW_OWN: ACTIVITY_MEASURE_VIEW_OWN,
  ACTIVITY_MEASURE_EDIT: ACTIVITY_MEASURE_EDIT,
  ACTIVITY_MEASURE_EDIT_OWN: ACTIVITY_MEASURE_EDIT_OWN,
  ACTIVITY_MEASURE_DELETE: ACTIVITY_MEASURE_DELETE,
  ACTIVITY_MEASURE_DELETE_OWN: ACTIVITY_MEASURE_DELETE_OWN,
  ACTIVITY_MEASURE_VALIDATE: ACTIVITY_MEASURE_VALIDATE,
  ACTIVITY_MEASURE_VALIDATE_OWN: ACTIVITY_MEASURE_VALIDATE_OWN,

  /**
   * System measure permissions
   */
  SYSTEM_MEASURE_CREATE: SYSTEM_MEASURE_CREATE,
  SYSTEM_MEASURE_CREATE_OWN: SYSTEM_MEASURE_CREATE_OWN,
  SYSTEM_MEASURE_VIEW: SYSTEM_MEASURE_VIEW,
  SYSTEM_MEASURE_VIEW_OWN: SYSTEM_MEASURE_VIEW_OWN,
  SYSTEM_MEASURE_EDIT: SYSTEM_MEASURE_EDIT,
  SYSTEM_MEASURE_EDIT_OWN: SYSTEM_MEASURE_EDIT_OWN,
  SYSTEM_MEASURE_DELETE: SYSTEM_MEASURE_DELETE,
  SYSTEM_MEASURE_DELETE_OWN: SYSTEM_MEASURE_DELETE_OWN,
  SYSTEM_MEASURE_VALIDATE: SYSTEM_MEASURE_VALIDATE,
  SYSTEM_MEASURE_VALIDATE_OWN: SYSTEM_MEASURE_VALIDATE_OWN,

  /**
   * Third party measure permissions
   */
  THIRD_PARTY_MEASURE_CREATE: THIRD_PARTY_MEASURE_CREATE,
  THIRD_PARTY_MEASURE_CREATE_OWN: THIRD_PARTY_MEASURE_CREATE_OWN,
  THIRD_PARTY_MEASURE_VIEW: THIRD_PARTY_MEASURE_VIEW,
  THIRD_PARTY_MEASURE_VIEW_OWN: THIRD_PARTY_MEASURE_VIEW_OWN,
  THIRD_PARTY_MEASURE_EDIT: THIRD_PARTY_MEASURE_EDIT,
  THIRD_PARTY_MEASURE_EDIT_OWN: THIRD_PARTY_MEASURE_EDIT_OWN,
  THIRD_PARTY_MEASURE_DELETE: THIRD_PARTY_MEASURE_DELETE,
  THIRD_PARTY_MEASURE_DELETE_OWN: THIRD_PARTY_MEASURE_DELETE_OWN,
  THIRD_PARTY_MEASURE_VALIDATE: THIRD_PARTY_MEASURE_VALIDATE,
  THIRD_PARTY_MEASURE_VALIDATE_OWN: THIRD_PARTY_MEASURE_VALIDATE_OWN,

  /**
   * Generic control measure permissions
   */
  GENERIC_CONTROL_MEASURE_CREATE: GENERIC_CONTROL_MEASURE_CREATE,
  GENERIC_CONTROL_MEASURE_CREATE_OWN: GENERIC_CONTROL_MEASURE_CREATE_OWN,
  GENERIC_CONTROL_MEASURE_VIEW: GENERIC_CONTROL_MEASURE_VIEW,
  GENERIC_CONTROL_MEASURE_VIEW_OWN: GENERIC_CONTROL_MEASURE_VIEW_OWN,
  GENERIC_CONTROL_MEASURE_EDIT: GENERIC_CONTROL_MEASURE_EDIT,
  GENERIC_CONTROL_MEASURE_EDIT_OWN: GENERIC_CONTROL_MEASURE_EDIT_OWN,
  GENERIC_CONTROL_MEASURE_DELETE: GENERIC_CONTROL_MEASURE_DELETE,
  GENERIC_CONTROL_MEASURE_DELETE_OWN: GENERIC_CONTROL_MEASURE_DELETE_OWN,
  GENERIC_CONTROL_MEASURE_VALIDATE: GENERIC_CONTROL_MEASURE_VALIDATE,
  GENERIC_CONTROL_MEASURE_VALIDATE_OWN: GENERIC_CONTROL_MEASURE_VALIDATE_OWN,

  // Organizations permissions
  ORGANIZATION_CREATE: ORGANIZATION_CREATE,
  ORGANIZATION_VIEW: ORGANIZATION_VIEW,
  ORGANIZATION_VIEW_OWN: ORGANIZATION_VIEW_OWN,
  ORGANIZATION_EDIT: ORGANIZATION_EDIT,
  ORGANIZATION_EDIT_OWN: ORGANIZATION_EDIT_OWN,
  ORGANIZATION_DELETE: ORGANIZATION_DELETE,
  ORGANIZATION_DELETE_OWN: ORGANIZATION_DELETE_OWN,

  // Process group permissions
  PROCESS_GROUP_CREATE: PROCESS_GROUP_CREATE,
  PROCESS_GROUP_VIEW: PROCESS_GROUP_VIEW,
  PROCESS_GROUP_VIEW_OWN: PROCESS_GROUP_VIEW_OWN,
  PROCESS_GROUP_EDIT: PROCESS_GROUP_EDIT,
  PROCESS_GROUP_EDIT_OWN: PROCESS_GROUP_EDIT_OWN,
  PROCESS_GROUP_DELETE: PROCESS_GROUP_DELETE,
  PROCESS_GROUP_DELETE_OWN: PROCESS_GROUP_DELETE_OWN,

  // Legal basis permissions
  LEGAL_BASIS_CREATE: LEGAL_BASIS_CREATE,
  LEGAL_BASIS_VIEW: LEGAL_BASIS_VIEW,
  LEGAL_BASIS_VIEW_OWN: LEGAL_BASIS_VIEW_OWN,
  LEGAL_BASIS_EDIT: LEGAL_BASIS_EDIT,
  LEGAL_BASIS_EDIT_OWN: LEGAL_BASIS_EDIT_OWN,
  LEGAL_BASIS_DELETE: LEGAL_BASIS_DELETE,
  LEGAL_BASIS_DELETE_OWN: LEGAL_BASIS_DELETE_OWN,
  LEGAL_BASIS_VALIDATE: LEGAL_BASIS_VALIDATE,
  LEGAL_BASIS_VALIDATE_OWN: LEGAL_BASIS_VALIDATE_OWN,

  // Information obligation permissions
  INFORMATION_OBLIGATION_CREATE: INFORMATION_OBLIGATION_CREATE,
  INFORMATION_OBLIGATION_VIEW: INFORMATION_OBLIGATION_VIEW,
  INFORMATION_OBLIGATION_VIEW_OWN: INFORMATION_OBLIGATION_VIEW_OWN,
  INFORMATION_OBLIGATION_EDIT: INFORMATION_OBLIGATION_EDIT,
  INFORMATION_OBLIGATION_EDIT_OWN: INFORMATION_OBLIGATION_EDIT_OWN,
  INFORMATION_OBLIGATION_DELETE: INFORMATION_OBLIGATION_DELETE,
  INFORMATION_OBLIGATION_DELETE_OWN: INFORMATION_OBLIGATION_DELETE_OWN,
  INFORMATION_OBLIGATION_VALIDATE: INFORMATION_OBLIGATION_VALIDATE,
  INFORMATION_OBLIGATION_VALIDATE_OWN: INFORMATION_OBLIGATION_VALIDATE_OWN,

  // Access control permissions
  ACCESS_CONTROL_CREATE: ACCESS_CONTROL_CREATE,
  ACCESS_CONTROL_VIEW: ACCESS_CONTROL_VIEW,
  ACCESS_CONTROL_VIEW_OWN: ACCESS_CONTROL_VIEW_OWN,
  ACCESS_CONTROL_EDIT: ACCESS_CONTROL_EDIT,
  ACCESS_CONTROL_EDIT_OWN: ACCESS_CONTROL_EDIT_OWN,
  ACCESS_CONTROL_DELETE: ACCESS_CONTROL_DELETE,
  ACCESS_CONTROL_DELETE_OWN: ACCESS_CONTROL_DELETE_OWN,
  ACCESS_CONTROL_VALIDATE: ACCESS_CONTROL_VALIDATE,
  ACCESS_CONTROL_VALIDATE_OWN: ACCESS_CONTROL_VALIDATE_OWN,

  // Data discovery permissions
  DATA_DISCOVERY_CREATE: DATA_DISCOVERY_CREATE,
  DATA_DISCOVERY_VIEW: DATA_DISCOVERY_VIEW,
  DATA_DISCOVERY_VIEW_OWN: DATA_DISCOVERY_VIEW_OWN,
  DATA_DISCOVERY_EDIT: DATA_DISCOVERY_EDIT,
  DATA_DISCOVERY_EDIT_OWN: DATA_DISCOVERY_EDIT_OWN,
  DATA_DISCOVERY_DELETE: DATA_DISCOVERY_DELETE,
  DATA_DISCOVERY_DELETE_OWN: DATA_DISCOVERY_DELETE_OWN,
  DATA_DISCOVERY_VALIDATE: DATA_DISCOVERY_VALIDATE,
  DATA_DISCOVERY_VALIDATE_OWN: DATA_DISCOVERY_VALIDATE_OWN,

  // Log management permissions
  LOG_MANAGEMENT_CREATE: LOG_MANAGEMENT_CREATE,
  LOG_MANAGEMENT_VIEW: LOG_MANAGEMENT_VIEW,
  LOG_MANAGEMENT_VIEW_OWN: LOG_MANAGEMENT_VIEW_OWN,
  LOG_MANAGEMENT_EDIT: LOG_MANAGEMENT_EDIT,
  LOG_MANAGEMENT_EDIT_OWN: LOG_MANAGEMENT_EDIT_OWN,
  LOG_MANAGEMENT_DELETE: LOG_MANAGEMENT_DELETE,
  LOG_MANAGEMENT_DELETE_OWN: LOG_MANAGEMENT_DELETE_OWN,
  LOG_MANAGEMENT_VALIDATE: LOG_MANAGEMENT_VALIDATE,
  LOG_MANAGEMENT_VALIDATE_OWN: LOG_MANAGEMENT_VALIDATE_OWN,

  // Risk category permissions
  RISK_CATEGORY_CREATE: RISK_CATEGORY_CREATE,
  RISK_CATEGORY_VIEW: RISK_CATEGORY_VIEW,
  RISK_CATEGORY_VIEW_OWN: RISK_CATEGORY_VIEW_OWN,
  RISK_CATEGORY_EDIT: RISK_CATEGORY_EDIT,
  RISK_CATEGORY_EDIT_OWN: RISK_CATEGORY_EDIT_OWN,
  RISK_CATEGORY_DELETE: RISK_CATEGORY_DELETE,
  RISK_CATEGORY_DELETE_OWN: RISK_CATEGORY_DELETE_OWN,

  // Network permissions
  NETWORK_CREATE: NETWORK_CREATE,
  NETWORK_VIEW: NETWORK_VIEW,
  NETWORK_VIEW_OWN: NETWORK_VIEW_OWN,
  NETWORK_EDIT: NETWORK_EDIT,
  NETWORK_EDIT_OWN: NETWORK_EDIT_OWN,
  NETWORK_DELETE: NETWORK_DELETE,
  NETWORK_DELETE_OWN: NETWORK_DELETE_OWN,
  NETWORK_VALIDATE: NETWORK_VALIDATE,
  NETWORK_VALIDATE_OWN: NETWORK_VALIDATE_OWN,

  // Data subject permissions
  DATA_SUBJECT_CREATE: DATA_SUBJECT_CREATE,
  DATA_SUBJECT_VIEW: DATA_SUBJECT_VIEW,
  DATA_SUBJECT_VIEW_OWN: DATA_SUBJECT_VIEW_OWN,
  DATA_SUBJECT_EDIT: DATA_SUBJECT_EDIT,
  DATA_SUBJECT_EDIT_OWN: DATA_SUBJECT_EDIT_OWN,
  DATA_SUBJECT_DELETE: DATA_SUBJECT_DELETE,
  DATA_SUBJECT_DELETE_OWN: DATA_SUBJECT_DELETE_OWN,

  // Retention rule permissions
  RETENTION_RULE_CREATE: RETENTION_RULE_CREATE,
  RETENTION_RULE_VIEW: RETENTION_RULE_VIEW,
  RETENTION_RULE_VIEW_OWN: RETENTION_RULE_VIEW_OWN,
  RETENTION_RULE_EDIT: RETENTION_RULE_EDIT,
  RETENTION_RULE_EDIT_OWN: RETENTION_RULE_EDIT_OWN,
  RETENTION_RULE_DELETE: RETENTION_RULE_DELETE,
  RETENTION_RULE_DELETE_OWN: RETENTION_RULE_DELETE_OWN,

  // Data object permissions
  DATA_OBJECT_CREATE: DATA_OBJECT_CREATE,
  DATA_OBJECT_VIEW: DATA_OBJECT_VIEW,
  DATA_OBJECT_VIEW_OWN: DATA_OBJECT_VIEW_OWN,
  DATA_OBJECT_EDIT: DATA_OBJECT_EDIT,
  DATA_OBJECT_EDIT_OWN: DATA_OBJECT_EDIT_OWN,
  DATA_OBJECT_DELETE: DATA_OBJECT_DELETE,
  DATA_OBJECT_DELETE_OWN: DATA_OBJECT_DELETE_OWN,
  DATA_OBJECT_VALIDATE: DATA_OBJECT_VALIDATE,
  DATA_OBJECT_VALIDATE_OWN: DATA_OBJECT_VALIDATE_OWN,

  // Process permissions
  PROCESS_CREATE: PROCESS_CREATE,
  PROCESS_VIEW: PROCESS_VIEW,
  PROCESS_VIEW_OWN: PROCESS_VIEW_OWN,
  PROCESS_EDIT: PROCESS_EDIT,
  PROCESS_EDIT_OWN: PROCESS_EDIT_OWN,
  PROCESS_DELETE: PROCESS_DELETE,
  PROCESS_DELETE_OWN: PROCESS_DELETE_OWN,

  // Process activity permissions
  PROCESS_ACTIVITY_CREATE: PROCESS_ACTIVITY_CREATE,
  PROCESS_ACTIVITY_CREATE_OWN: PROCESS_ACTIVITY_CREATE_OWN,
  PROCESS_ACTIVITY_VIEW: PROCESS_ACTIVITY_VIEW,
  PROCESS_ACTIVITY_VIEW_OWN: PROCESS_ACTIVITY_VIEW_OWN,
  PROCESS_ACTIVITY_EDIT: PROCESS_ACTIVITY_EDIT,
  PROCESS_ACTIVITY_EDIT_OWN: PROCESS_ACTIVITY_EDIT_OWN,
  PROCESS_ACTIVITY_DELETE: PROCESS_ACTIVITY_DELETE,
  PROCESS_ACTIVITY_DELETE_OWN: PROCESS_ACTIVITY_DELETE_OWN,

  // Process policy permissions
  PROCESS_POLICY_CREATE: PROCESS_POLICY_CREATE,
  PROCESS_POLICY_CREATE_OWN: PROCESS_POLICY_CREATE_OWN,
  PROCESS_POLICY_VIEW: PROCESS_POLICY_VIEW,
  PROCESS_POLICY_VIEW_OWN: PROCESS_POLICY_VIEW_OWN,
  PROCESS_POLICY_EDIT: PROCESS_POLICY_EDIT,
  PROCESS_POLICY_EDIT_OWN: PROCESS_POLICY_EDIT_OWN,
  PROCESS_POLICY_DELETE: PROCESS_POLICY_DELETE,
  PROCESS_POLICY_DELETE_OWN: PROCESS_POLICY_DELETE_OWN,

  // Process legal basis permissions
  PROCESS_LEGAL_BASIS_CREATE: PROCESS_LEGAL_BASIS_CREATE,
  PROCESS_LEGAL_BASIS_CREATE_OWN: PROCESS_LEGAL_BASIS_CREATE_OWN,
  PROCESS_LEGAL_BASIS_VIEW: PROCESS_LEGAL_BASIS_VIEW,
  PROCESS_LEGAL_BASIS_VIEW_OWN: PROCESS_LEGAL_BASIS_VIEW_OWN,
  PROCESS_LEGAL_BASIS_EDIT: PROCESS_LEGAL_BASIS_EDIT,
  PROCESS_LEGAL_BASIS_EDIT_OWN: PROCESS_LEGAL_BASIS_EDIT_OWN,
  PROCESS_LEGAL_BASIS_DELETE: PROCESS_LEGAL_BASIS_DELETE,
  PROCESS_LEGAL_BASIS_DELETE_OWN: PROCESS_LEGAL_BASIS_DELETE_OWN,
  PROCESS_LEGAL_BASIS_VALIDATE: PROCESS_LEGAL_BASIS_VALIDATE,
  PROCESS_LEGAL_BASIS_VALIDATE_OWN: PROCESS_LEGAL_BASIS_VALIDATE_OWN,

  // Process information obligation permissions
  PROCESS_INFORMATION_OBLIGATION_CREATE: PROCESS_INFORMATION_OBLIGATION_CREATE,
  PROCESS_INFORMATION_OBLIGATION_CREATE_OWN: PROCESS_INFORMATION_OBLIGATION_CREATE_OWN,
  PROCESS_INFORMATION_OBLIGATION_VIEW: PROCESS_INFORMATION_OBLIGATION_VIEW,
  PROCESS_INFORMATION_OBLIGATION_VIEW_OWN: PROCESS_INFORMATION_OBLIGATION_VIEW_OWN,
  PROCESS_INFORMATION_OBLIGATION_EDIT: PROCESS_INFORMATION_OBLIGATION_EDIT,
  PROCESS_INFORMATION_OBLIGATION_EDIT_OWN: PROCESS_INFORMATION_OBLIGATION_EDIT_OWN,
  PROCESS_INFORMATION_OBLIGATION_DELETE: PROCESS_INFORMATION_OBLIGATION_DELETE,
  PROCESS_INFORMATION_OBLIGATION_DELETE_OWN: PROCESS_INFORMATION_OBLIGATION_DELETE_OWN,
  PROCESS_INFORMATION_OBLIGATION_VALIDATE: PROCESS_INFORMATION_OBLIGATION_VALIDATE,
  PROCESS_INFORMATION_OBLIGATION_VALIDATE_OWN: PROCESS_INFORMATION_OBLIGATION_VALIDATE_OWN,

  // Process confidentiality permissions
  PROCESS_CONFIDENTIALITY_VIEW: PROCESS_CONFIDENTIALITY_VIEW,
  PROCESS_CONFIDENTIALITY_VIEW_OWN: PROCESS_CONFIDENTIALITY_VIEW_OWN,
  PROCESS_CONFIDENTIALITY_EDIT: PROCESS_CONFIDENTIALITY_EDIT,
  PROCESS_CONFIDENTIALITY_EDIT_OWN: PROCESS_CONFIDENTIALITY_EDIT_OWN,
  PROCESS_CONFIDENTIALITY_VALIDATE: PROCESS_CONFIDENTIALITY_VALIDATE,
  PROCESS_CONFIDENTIALITY_VALIDATE_OWN: PROCESS_CONFIDENTIALITY_VALIDATE_OWN,

  // Process integrity permissions
  PROCESS_INTEGRITY_VIEW: PROCESS_INTEGRITY_VIEW,
  PROCESS_INTEGRITY_VIEW_OWN: PROCESS_INTEGRITY_VIEW_OWN,
  PROCESS_INTEGRITY_EDIT: PROCESS_INTEGRITY_EDIT,
  PROCESS_INTEGRITY_EDIT_OWN: PROCESS_INTEGRITY_EDIT_OWN,
  PROCESS_INTEGRITY_VALIDATE: PROCESS_INTEGRITY_VALIDATE,
  PROCESS_INTEGRITY_VALIDATE_OWN: PROCESS_INTEGRITY_VALIDATE_OWN,

  // Process available permissions
  PROCESS_AVAILABILITY_VIEW: PROCESS_AVAILABILITY_VIEW,
  PROCESS_AVAILABILITY_VIEW_OWN: PROCESS_AVAILABILITY_VIEW_OWN,
  PROCESS_AVAILABILITY_EDIT: PROCESS_AVAILABILITY_EDIT,
  PROCESS_AVAILABILITY_EDIT_OWN: PROCESS_AVAILABILITY_EDIT_OWN,
  PROCESS_AVAILABILITY_VALIDATE: PROCESS_AVAILABILITY_VALIDATE,
  PROCESS_AVAILABILITY_VALIDATE_OWN: PROCESS_AVAILABILITY_VALIDATE_OWN,

  /**
   * Process risk profile permissions
   */
  PROCESS_RISK_VIEW:PROCESS_RISK_VIEW,
  PROCESS_RISK_VIEW_OWN:PROCESS_RISK_VIEW_OWN,
  PROCESS_RISK_EDIT:PROCESS_RISK_EDIT,
  PROCESS_RISK_EDIT_OWN:PROCESS_RISK_EDIT_OWN,
  PROCESS_RISK_VALIDATION:PROCESS_RISK_VALIDATION,
  PROCESS_RISK_VALIDATION_OWN:PROCESS_RISK_VALIDATION_OWN,

  // System permissions
  SYSTEM_CREATE: SYSTEM_CREATE,
  SYSTEM_VIEW: SYSTEM_VIEW,
  SYSTEM_VIEW_OWN: SYSTEM_VIEW_OWN,
  SYSTEM_EDIT: SYSTEM_EDIT,
  SYSTEM_EDIT_OWN: SYSTEM_EDIT_OWN,
  SYSTEM_DELETE: SYSTEM_DELETE,
  SYSTEM_DELETE_OWN: SYSTEM_DELETE_OWN,

  // System policy permissions
  SYSTEM_POLICY_CREATE: SYSTEM_POLICY_CREATE,
  SYSTEM_POLICY_CREATE_OWN: SYSTEM_POLICY_CREATE_OWN,
  SYSTEM_POLICY_VIEW: SYSTEM_POLICY_VIEW,
  SYSTEM_POLICY_VIEW_OWN: SYSTEM_POLICY_VIEW_OWN,
  SYSTEM_POLICY_EDIT: SYSTEM_POLICY_EDIT,
  SYSTEM_POLICY_EDIT_OWN: SYSTEM_POLICY_EDIT_OWN,
  SYSTEM_POLICY_DELETE: SYSTEM_POLICY_DELETE,
  SYSTEM_POLICY_DELETE_OWN: SYSTEM_POLICY_DELETE_OWN,

  // System third party permissions
  SYSTEM_THIRD_PARTY_CREATE: SYSTEM_THIRD_PARTY_CREATE,
  SYSTEM_THIRD_PARTY_CREATE_OWN: SYSTEM_THIRD_PARTY_CREATE_OWN,
  SYSTEM_THIRD_PARTY_VIEW: SYSTEM_THIRD_PARTY_VIEW,
  SYSTEM_THIRD_PARTY_VIEW_OWN: SYSTEM_THIRD_PARTY_VIEW_OWN,
  SYSTEM_THIRD_PARTY_EDIT: SYSTEM_THIRD_PARTY_EDIT,
  SYSTEM_THIRD_PARTY_EDIT_OWN: SYSTEM_THIRD_PARTY_EDIT_OWN,
  SYSTEM_THIRD_PARTY_DELETE: SYSTEM_THIRD_PARTY_DELETE,
  SYSTEM_THIRD_PARTY_DELETE_OWN: SYSTEM_THIRD_PARTY_DELETE_OWN,
  SYSTEM_THIRD_PARTY_VALIDATE: SYSTEM_THIRD_PARTY_VALIDATE,
  SYSTEM_THIRD_PARTY_VALIDATE_OWN: SYSTEM_THIRD_PARTY_VALIDATE_OWN,

  // System access control permissions
  SYSTEM_ACCESS_CONTROL_CREATE: SYSTEM_ACCESS_CONTROL_CREATE,
  SYSTEM_ACCESS_CONTROL_CREATE_OWN: SYSTEM_ACCESS_CONTROL_CREATE_OWN,
  SYSTEM_ACCESS_CONTROL_VIEW: SYSTEM_ACCESS_CONTROL_VIEW,
  SYSTEM_ACCESS_CONTROL_VIEW_OWN: SYSTEM_ACCESS_CONTROL_VIEW_OWN,
  SYSTEM_ACCESS_CONTROL_EDIT: SYSTEM_ACCESS_CONTROL_EDIT,
  SYSTEM_ACCESS_CONTROL_EDIT_OWN: SYSTEM_ACCESS_CONTROL_EDIT_OWN,
  SYSTEM_ACCESS_CONTROL_DELETE: SYSTEM_ACCESS_CONTROL_DELETE,
  SYSTEM_ACCESS_CONTROL_DELETE_OWN: SYSTEM_ACCESS_CONTROL_DELETE_OWN,
  SYSTEM_ACCESS_CONTROL_VALIDATE: SYSTEM_ACCESS_CONTROL_VALIDATE,
  SYSTEM_ACCESS_CONTROL_VALIDATE_OWN: SYSTEM_ACCESS_CONTROL_VALIDATE_OWN,

  // System data discovery permissions
  SYSTEM_DATA_DISCOVERY_CREATE: SYSTEM_DATA_DISCOVERY_CREATE,
  SYSTEM_DATA_DISCOVERY_CREATE_OWN: SYSTEM_DATA_DISCOVERY_CREATE_OWN,
  SYSTEM_DATA_DISCOVERY_VIEW: SYSTEM_DATA_DISCOVERY_VIEW,
  SYSTEM_DATA_DISCOVERY_VIEW_OWN: SYSTEM_DATA_DISCOVERY_VIEW_OWN,
  SYSTEM_DATA_DISCOVERY_EDIT: SYSTEM_DATA_DISCOVERY_EDIT,
  SYSTEM_DATA_DISCOVERY_EDIT_OWN: SYSTEM_DATA_DISCOVERY_EDIT_OWN,
  SYSTEM_DATA_DISCOVERY_DELETE: SYSTEM_DATA_DISCOVERY_DELETE,
  SYSTEM_DATA_DISCOVERY_DELETE_OWN: SYSTEM_DATA_DISCOVERY_DELETE_OWN,
  SYSTEM_DATA_DISCOVERY_VALIDATE: SYSTEM_DATA_DISCOVERY_VALIDATE,
  SYSTEM_DATA_DISCOVERY_VALIDATE_OWN: SYSTEM_DATA_DISCOVERY_VALIDATE_OWN,

  // System log management permissions
  SYSTEM_LOG_MANAGEMENT_CREATE: SYSTEM_LOG_MANAGEMENT_CREATE,
  SYSTEM_LOG_MANAGEMENT_CREATE_OWN: SYSTEM_LOG_MANAGEMENT_CREATE_OWN,
  SYSTEM_LOG_MANAGEMENT_VIEW: SYSTEM_LOG_MANAGEMENT_VIEW,
  SYSTEM_LOG_MANAGEMENT_VIEW_OWN: SYSTEM_LOG_MANAGEMENT_VIEW_OWN,
  SYSTEM_LOG_MANAGEMENT_EDIT: SYSTEM_LOG_MANAGEMENT_EDIT,
  SYSTEM_LOG_MANAGEMENT_EDIT_OWN: SYSTEM_LOG_MANAGEMENT_EDIT_OWN,
  SYSTEM_LOG_MANAGEMENT_DELETE: SYSTEM_LOG_MANAGEMENT_DELETE,
  SYSTEM_LOG_MANAGEMENT_DELETE_OWN: SYSTEM_LOG_MANAGEMENT_DELETE_OWN,
  SYSTEM_LOG_MANAGEMENT_VALIDATE: SYSTEM_LOG_MANAGEMENT_VALIDATE,
  SYSTEM_LOG_MANAGEMENT_VALIDATE_OWN: SYSTEM_LOG_MANAGEMENT_VALIDATE_OWN,

  // System network permissions
  SYSTEM_NETWORK_CREATE: SYSTEM_NETWORK_CREATE,
  SYSTEM_NETWORK_CREATE_OWN: SYSTEM_NETWORK_CREATE_OWN,
  SYSTEM_NETWORK_VIEW: SYSTEM_NETWORK_VIEW,
  SYSTEM_NETWORK_VIEW_OWN: SYSTEM_NETWORK_VIEW_OWN,
  SYSTEM_NETWORK_EDIT: SYSTEM_NETWORK_EDIT,
  SYSTEM_NETWORK_EDIT_OWN: SYSTEM_NETWORK_EDIT_OWN,
  SYSTEM_NETWORK_DELETE: SYSTEM_NETWORK_DELETE,
  SYSTEM_NETWORK_DELETE_OWN: SYSTEM_NETWORK_DELETE_OWN,
  SYSTEM_NETWORK_VALIDATE: SYSTEM_NETWORK_VALIDATE,
  SYSTEM_NETWORK_VALIDATE_OWN: SYSTEM_NETWORK_VALIDATE_OWN,

  // System data object permissions
  SYSTEM_DATA_OBJECT_CREATE: SYSTEM_DATA_OBJECT_CREATE,
  SYSTEM_DATA_OBJECT_CREATE_OWN: SYSTEM_DATA_OBJECT_CREATE_OWN,
  SYSTEM_DATA_OBJECT_VIEW: SYSTEM_DATA_OBJECT_VIEW,
  SYSTEM_DATA_OBJECT_VIEW_OWN: SYSTEM_DATA_OBJECT_VIEW_OWN,
  SYSTEM_DATA_OBJECT_EDIT: SYSTEM_DATA_OBJECT_EDIT,
  SYSTEM_DATA_OBJECT_EDIT_OWN: SYSTEM_DATA_OBJECT_EDIT_OWN,
  SYSTEM_DATA_OBJECT_DELETE: SYSTEM_DATA_OBJECT_DELETE,
  SYSTEM_DATA_OBJECT_DELETE_OWN: SYSTEM_DATA_OBJECT_DELETE_OWN,

  // Activity permissions
  ACTIVITY_CREATE: ACTIVITY_CREATE,
  ACTIVITY_VIEW: ACTIVITY_VIEW,
  ACTIVITY_VIEW_OWN: ACTIVITY_VIEW_OWN,
  ACTIVITY_EDIT: ACTIVITY_EDIT,
  ACTIVITY_EDIT_OWN: ACTIVITY_EDIT_OWN,
  ACTIVITY_DELETE: ACTIVITY_DELETE,
  ACTIVITY_DELETE_OWN: ACTIVITY_DELETE_OWN,

  // Activity policy permissions
  ACTIVITY_PROCESS_CREATE: ACTIVITY_PROCESS_CREATE,
  ACTIVITY_PROCESS_CREATE_OWN: ACTIVITY_PROCESS_CREATE_OWN,
  ACTIVITY_PROCESS_VIEW: ACTIVITY_PROCESS_VIEW,
  ACTIVITY_PROCESS_VIEW_OWN: ACTIVITY_PROCESS_VIEW_OWN,
  ACTIVITY_PROCESS_EDIT: ACTIVITY_PROCESS_EDIT,
  ACTIVITY_PROCESS_EDIT_OWN: ACTIVITY_PROCESS_EDIT_OWN,
  ACTIVITY_PROCESS_DELETE: ACTIVITY_PROCESS_DELETE,
  ACTIVITY_PROCESS_DELETE_OWN: ACTIVITY_PROCESS_DELETE_OWN,

  // Activity policy permissions
  ACTIVITY_POLICY_CREATE: ACTIVITY_POLICY_CREATE,
  ACTIVITY_POLICY_CREATE_OWN: ACTIVITY_POLICY_CREATE_OWN,
  ACTIVITY_POLICY_VIEW: ACTIVITY_POLICY_VIEW,
  ACTIVITY_POLICY_VIEW_OWN: ACTIVITY_POLICY_VIEW_OWN,
  ACTIVITY_POLICY_EDIT: ACTIVITY_POLICY_EDIT,
  ACTIVITY_POLICY_EDIT_OWN: ACTIVITY_POLICY_EDIT_OWN,
  ACTIVITY_POLICY_DELETE: ACTIVITY_POLICY_DELETE,
  ACTIVITY_POLICY_DELETE_OWN: ACTIVITY_POLICY_DELETE_OWN,

  // Activity system permissions
  ACTIVITY_SYSTEM_CREATE: ACTIVITY_SYSTEM_CREATE,
  ACTIVITY_SYSTEM_CREATE_OWN: ACTIVITY_SYSTEM_CREATE_OWN,
  ACTIVITY_SYSTEM_VIEW: ACTIVITY_SYSTEM_VIEW,
  ACTIVITY_SYSTEM_VIEW_OWN: ACTIVITY_SYSTEM_VIEW_OWN,
  ACTIVITY_SYSTEM_EDIT: ACTIVITY_SYSTEM_EDIT,
  ACTIVITY_SYSTEM_EDIT_OWN: ACTIVITY_SYSTEM_EDIT_OWN,
  ACTIVITY_SYSTEM_DELETE: ACTIVITY_SYSTEM_DELETE,
  ACTIVITY_SYSTEM_DELETE_OWN: ACTIVITY_SYSTEM_DELETE_OWN,
  ACTIVITY_SYSTEM_VALIDATE: ACTIVITY_SYSTEM_VALIDATE,
  ACTIVITY_SYSTEM_VALIDATE_OWN: ACTIVITY_SYSTEM_VALIDATE_OWN,

  // Activity third party source permissions
  ACTIVITY_THIRD_PARTY_SOURCE_CREATE: ACTIVITY_THIRD_PARTY_SOURCE_CREATE,
  ACTIVITY_THIRD_PARTY_SOURCE_CREATE_OWN: ACTIVITY_THIRD_PARTY_SOURCE_CREATE_OWN,
  ACTIVITY_THIRD_PARTY_SOURCE_VIEW: ACTIVITY_THIRD_PARTY_SOURCE_VIEW,
  ACTIVITY_THIRD_PARTY_SOURCE_VIEW_OWN: ACTIVITY_THIRD_PARTY_SOURCE_VIEW_OWN,
  ACTIVITY_THIRD_PARTY_SOURCE_EDIT: ACTIVITY_THIRD_PARTY_SOURCE_EDIT,
  ACTIVITY_THIRD_PARTY_SOURCE_EDIT_OWN: ACTIVITY_THIRD_PARTY_SOURCE_EDIT_OWN,
  ACTIVITY_THIRD_PARTY_SOURCE_DELETE: ACTIVITY_THIRD_PARTY_SOURCE_DELETE,
  ACTIVITY_THIRD_PARTY_SOURCE_DELETE_OWN: ACTIVITY_THIRD_PARTY_SOURCE_DELETE_OWN,
  ACTIVITY_THIRD_PARTY_SOURCE_VALIDATE: ACTIVITY_THIRD_PARTY_SOURCE_VALIDATE,
  ACTIVITY_THIRD_PARTY_SOURCE_VALIDATE_OWN: ACTIVITY_THIRD_PARTY_SOURCE_VALIDATE_OWN,

  // Activity third party receiver permissions
  ACTIVITY_THIRD_PARTY_RECEIVER_CREATE: ACTIVITY_THIRD_PARTY_RECEIVER_CREATE,
  ACTIVITY_THIRD_PARTY_RECEIVER_CREATE_OWN: ACTIVITY_THIRD_PARTY_RECEIVER_CREATE_OWN,
  ACTIVITY_THIRD_PARTY_RECEIVER_VIEW: ACTIVITY_THIRD_PARTY_RECEIVER_VIEW,
  ACTIVITY_THIRD_PARTY_RECEIVER_VIEW_OWN: ACTIVITY_THIRD_PARTY_RECEIVER_VIEW_OWN,
  ACTIVITY_THIRD_PARTY_RECEIVER_EDIT: ACTIVITY_THIRD_PARTY_RECEIVER_EDIT,
  ACTIVITY_THIRD_PARTY_RECEIVER_EDIT_OWN: ACTIVITY_THIRD_PARTY_RECEIVER_EDIT_OWN,
  ACTIVITY_THIRD_PARTY_RECEIVER_DELETE: ACTIVITY_THIRD_PARTY_RECEIVER_DELETE,
  ACTIVITY_THIRD_PARTY_RECEIVER_DELETE_OWN: ACTIVITY_THIRD_PARTY_RECEIVER_DELETE_OWN,
  ACTIVITY_THIRD_PARTY_RECEIVER_VALIDATE: ACTIVITY_THIRD_PARTY_RECEIVER_VALIDATE,
  ACTIVITY_THIRD_PARTY_RECEIVER_VALIDATE_OWN: ACTIVITY_THIRD_PARTY_RECEIVER_VALIDATE_OWN,

  // Activity data subject permissions
  ACTIVITY_DATA_SUBJECT_CREATE: ACTIVITY_DATA_SUBJECT_CREATE,
  ACTIVITY_DATA_SUBJECT_CREATE_OWN: ACTIVITY_DATA_SUBJECT_CREATE_OWN,
  ACTIVITY_DATA_SUBJECT_VIEW: ACTIVITY_DATA_SUBJECT_VIEW,
  ACTIVITY_DATA_SUBJECT_VIEW_OWN: ACTIVITY_DATA_SUBJECT_VIEW_OWN,
  ACTIVITY_DATA_SUBJECT_EDIT: ACTIVITY_DATA_SUBJECT_EDIT,
  ACTIVITY_DATA_SUBJECT_EDIT_OWN: ACTIVITY_DATA_SUBJECT_EDIT_OWN,
  ACTIVITY_DATA_SUBJECT_DELETE: ACTIVITY_DATA_SUBJECT_DELETE,
  ACTIVITY_DATA_SUBJECT_DELETE_OWN: ACTIVITY_DATA_SUBJECT_DELETE_OWN,

  // Activity retention rule permissions
  ACTIVITY_RETENTION_RULE_CREATE: ACTIVITY_RETENTION_RULE_CREATE,
  ACTIVITY_RETENTION_RULE_CREATE_OWN: ACTIVITY_RETENTION_RULE_CREATE_OWN,
  ACTIVITY_RETENTION_RULE_VIEW: ACTIVITY_RETENTION_RULE_VIEW,
  ACTIVITY_RETENTION_RULE_VIEW_OWN: ACTIVITY_RETENTION_RULE_VIEW_OWN,
  ACTIVITY_RETENTION_RULE_EDIT: ACTIVITY_RETENTION_RULE_EDIT,
  ACTIVITY_RETENTION_RULE_EDIT_OWN: ACTIVITY_RETENTION_RULE_EDIT_OWN,
  ACTIVITY_RETENTION_RULE_DELETE: ACTIVITY_RETENTION_RULE_DELETE,
  ACTIVITY_RETENTION_RULE_DELETE_OWN: ACTIVITY_RETENTION_RULE_DELETE_OWN,
  ACTIVITY_RETENTION_RULE_VALIDATE: ACTIVITY_RETENTION_RULE_VALIDATE,
  ACTIVITY_RETENTION_RULE_VALIDATE_OWN: ACTIVITY_RETENTION_RULE_VALIDATE_OWN,

  // Activity integrity permissions
  ACTIVITY_INTEGRITY_CREATE: ACTIVITY_INTEGRITY_CREATE,
  ACTIVITY_INTEGRITY_VIEW: ACTIVITY_INTEGRITY_VIEW,
  ACTIVITY_INTEGRITY_VIEW_OWN: ACTIVITY_INTEGRITY_VIEW_OWN,
  ACTIVITY_INTEGRITY_EDIT: ACTIVITY_INTEGRITY_EDIT,
  ACTIVITY_INTEGRITY_EDIT_OWN: ACTIVITY_INTEGRITY_EDIT_OWN,
  ACTIVITY_INTEGRITY_DELETE: ACTIVITY_INTEGRITY_DELETE,
  ACTIVITY_INTEGRITY_DELETE_OWN: ACTIVITY_INTEGRITY_DELETE_OWN,
  ACTIVITY_INTEGRITY_VALIDATE: ACTIVITY_INTEGRITY_VALIDATE,
  ACTIVITY_INTEGRITY_VALIDATE_OWN: ACTIVITY_INTEGRITY_VALIDATE_OWN,

  // Activity principles of proportionality permissions
  ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_CREATE: ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_CREATE,
  ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VIEW: ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VIEW,
  ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VIEW_OWN: ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VIEW_OWN,
  ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_EDIT: ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_EDIT,
  ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_EDIT_OWN: ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_EDIT_OWN,
  ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_DELETE: ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_DELETE,
  ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_DELETE_OWN: ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_DELETE_OWN,
  ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VALIDATE: ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VALIDATE,
  ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VALIDATE_OWN: ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VALIDATE_OWN,

  // Activity processing type permissions
  ACTIVITY_PROCESSING_TYPE_CREATE: ACTIVITY_PROCESSING_TYPE_CREATE,
  ACTIVITY_PROCESSING_TYPE_VIEW: ACTIVITY_PROCESSING_TYPE_VIEW,
  ACTIVITY_PROCESSING_TYPE_VIEW_OWN: ACTIVITY_PROCESSING_TYPE_VIEW_OWN,
  ACTIVITY_PROCESSING_TYPE_EDIT: ACTIVITY_PROCESSING_TYPE_EDIT,
  ACTIVITY_PROCESSING_TYPE_EDIT_OWN: ACTIVITY_PROCESSING_TYPE_EDIT_OWN,
  ACTIVITY_PROCESSING_TYPE_DELETE: ACTIVITY_PROCESSING_TYPE_DELETE,
  ACTIVITY_PROCESSING_TYPE_DELETE_OWN: ACTIVITY_PROCESSING_TYPE_DELETE_OWN,
  ACTIVITY_PROCESSING_TYPE_VALIDATE: ACTIVITY_PROCESSING_TYPE_VALIDATE,
  ACTIVITY_PROCESSING_TYPE_VALIDATE_OWN: ACTIVITY_PROCESSING_TYPE_VALIDATE_OWN,

  /**
   * Activity organizations permissions
   */
  ACTIVITY_ORGANIZATION_CREATE: ACTIVITY_ORGANIZATION_CREATE,
  ACTIVITY_ORGANIZATION_CREATE_OWN: ACTIVITY_ORGANIZATION_CREATE_OWN,
  ACTIVITY_ORGANIZATION_VIEW: ACTIVITY_ORGANIZATION_VIEW,
  ACTIVITY_ORGANIZATION_VIEW_OWN: ACTIVITY_ORGANIZATION_VIEW_OWN,
  ACTIVITY_ORGANIZATION_EDIT: ACTIVITY_ORGANIZATION_EDIT,
  ACTIVITY_ORGANIZATION_EDIT_OWN: ACTIVITY_ORGANIZATION_EDIT_OWN,
  ACTIVITY_ORGANIZATION_DELETE: ACTIVITY_ORGANIZATION_DELETE,
  ACTIVITY_ORGANIZATION_DELETE_OWN: ACTIVITY_ORGANIZATION_DELETE_OWN,

  /**
   * Activity integrity controls permissions
   */
  ACTIVITY_INTEGRITY_CONTROL_CREATE: ACTIVITY_INTEGRITY_CONTROL_CREATE,
  ACTIVITY_INTEGRITY_CONTROL_CREATE_OWN: ACTIVITY_INTEGRITY_CONTROL_CREATE_OWN,
  ACTIVITY_INTEGRITY_CONTROL_VIEW: ACTIVITY_INTEGRITY_CONTROL_VIEW,
  ACTIVITY_INTEGRITY_CONTROL_VIEW_OWN: ACTIVITY_INTEGRITY_CONTROL_VIEW_OWN,
  ACTIVITY_INTEGRITY_CONTROL_EDIT: ACTIVITY_INTEGRITY_CONTROL_EDIT,
  ACTIVITY_INTEGRITY_CONTROL_EDIT_OWN: ACTIVITY_INTEGRITY_CONTROL_EDIT_OWN,
  ACTIVITY_INTEGRITY_CONTROL_DELETE: ACTIVITY_INTEGRITY_CONTROL_DELETE,
  ACTIVITY_INTEGRITY_CONTROL_DELETE_OWN: ACTIVITY_INTEGRITY_CONTROL_DELETE_OWN,

  /**
   * Activity risk scenario permissions
   */
  ACTIVITY_RISK_SCENARIO_CREATE: ACTIVITY_RISK_SCENARIO_CREATE,
  ACTIVITY_RISK_SCENARIO_CREATE_OWN: ACTIVITY_RISK_SCENARIO_CREATE_OWN,
  ACTIVITY_RISK_SCENARIO_VIEW: ACTIVITY_RISK_SCENARIO_VIEW,
  ACTIVITY_RISK_SCENARIO_VIEW_OWN: ACTIVITY_RISK_SCENARIO_VIEW_OWN,
  ACTIVITY_RISK_SCENARIO_EDIT: ACTIVITY_RISK_SCENARIO_EDIT,
  ACTIVITY_RISK_SCENARIO_EDIT_OWN: ACTIVITY_RISK_SCENARIO_EDIT_OWN,
  ACTIVITY_RISK_SCENARIO_DELETE: ACTIVITY_RISK_SCENARIO_DELETE,
  ACTIVITY_RISK_SCENARIO_DELETE_OWN: ACTIVITY_RISK_SCENARIO_DELETE_OWN,
  ACTIVITY_RISK_SCENARIO_VALIDATE: ACTIVITY_RISK_SCENARIO_VALIDATE,
  ACTIVITY_RISK_SCENARIO_VALIDATE_OWN: ACTIVITY_RISK_SCENARIO_VALIDATE_OWN,

  /**
   * Campaign template permissions
   */
  CAMPAIGN_TEMPLATE_CREATE: CAMPAIGN_TEMPLATE_CREATE,
  CAMPAIGN_TEMPLATE_VIEW: CAMPAIGN_TEMPLATE_VIEW,
  CAMPAIGN_TEMPLATE_VIEW_OWN: CAMPAIGN_TEMPLATE_VIEW_OWN,
  CAMPAIGN_TEMPLATE_EDIT: CAMPAIGN_TEMPLATE_EDIT,
  CAMPAIGN_TEMPLATE_EDIT_OWN: CAMPAIGN_TEMPLATE_EDIT_OWN,
  CAMPAIGN_TEMPLATE_DELETE: CAMPAIGN_TEMPLATE_DELETE,
  CAMPAIGN_TEMPLATE_DELETE_OWN: CAMPAIGN_TEMPLATE_DELETE_OWN,

  /**
   * Campaign permissions
   */
  CAMPAIGN_CREATE: CAMPAIGN_CREATE,
  CAMPAIGN_CREATE_OWN: CAMPAIGN_CREATE_OWN,
  CAMPAIGN_VIEW: CAMPAIGN_VIEW,
  CAMPAIGN_VIEW_OWN: CAMPAIGN_VIEW_OWN,
  CAMPAIGN_EDIT: CAMPAIGN_EDIT,
  CAMPAIGN_EDIT_OWN: CAMPAIGN_EDIT_OWN,
  CAMPAIGN_DELETE: CAMPAIGN_DELETE,
  CAMPAIGN_DELETE_OWN: CAMPAIGN_DELETE_OWN,

  /**
   * Project permissions
   */
  PROJECT_CREATE: PROJECT_CREATE,
  PROJECT_CREATE_OWN: PROJECT_CREATE_OWN,
  PROJECT_VIEW: PROJECT_VIEW,
  PROJECT_VIEW_OWN: PROJECT_VIEW_OWN,
  PROJECT_EDIT: PROJECT_EDIT,
  PROJECT_EDIT_OWN: PROJECT_EDIT_OWN,
  PROJECT_DELETE: PROJECT_DELETE,
  PROJECT_DELETE_OWN: PROJECT_DELETE_OWN,

  /**
   * Guide permissions
   */
  GUIDE_CREATE: GUIDE_CREATE,
  GUIDE_VIEW: GUIDE_VIEW,
  GUIDE_VIEW_OWN: GUIDE_VIEW_OWN,
  GUIDE_EDIT: GUIDE_EDIT,
  GUIDE_EDIT_OWN: GUIDE_EDIT_OWN,
  GUIDE_DELETE: GUIDE_DELETE,
  GUIDE_DELETE_OWN: GUIDE_DELETE_OWN,


  /**
   * Actors permissions
   */
  ACTOR_CREATE: ACTOR_CREATE,
  ACTOR_VIEW: ACTOR_VIEW,
  ACTOR_VIEW_OWN: ACTOR_VIEW_OWN,
  ACTOR_EDIT: ACTOR_EDIT,
  ACTOR_EDIT_OWN: ACTOR_EDIT_OWN,
  ACTOR_DELETE: ACTOR_DELETE,
  ACTOR_DELETE_OWN: ACTOR_DELETE_OWN,

  /**
   * Threats permissions
   */
  THREAT_CREATE: THREAT_CREATE,
  THREAT_VIEW: THREAT_VIEW,
  THREAT_VIEW_OWN: THREAT_VIEW_OWN,
  THREAT_EDIT: THREAT_EDIT,
  THREAT_EDIT_OWN: THREAT_EDIT_OWN,
  THREAT_DELETE: THREAT_DELETE,
  THREAT_DELETE_OWN: THREAT_DELETE_OWN,

  /**
   * Vulnerabilities permissions
   */
  VULNERABILITY_CREATE: VULNERABILITY_CREATE,
  VULNERABILITY_VIEW: VULNERABILITY_VIEW,
  VULNERABILITY_VIEW_OWN: VULNERABILITY_VIEW_OWN,
  VULNERABILITY_EDIT: VULNERABILITY_EDIT,
  VULNERABILITY_EDIT_OWN: VULNERABILITY_EDIT_OWN,
  VULNERABILITY_DELETE: VULNERABILITY_DELETE,
  VULNERABILITY_DELETE_OWN: VULNERABILITY_DELETE_OWN,

  /**
   * Framework permissions
   */
  FRAMEWORK_CREATE: FRAMEWORK_CREATE,
  FRAMEWORK_VIEW: FRAMEWORK_VIEW,
  FRAMEWORK_VIEW_OWN: FRAMEWORK_VIEW_OWN,
  FRAMEWORK_EDIT: FRAMEWORK_EDIT,
  FRAMEWORK_EDIT_OWN: FRAMEWORK_EDIT_OWN,
  FRAMEWORK_DELETE: FRAMEWORK_DELETE,
  FRAMEWORK_DELETE_OWN: FRAMEWORK_DELETE_OWN,

  /**
   * Control objective permissions
   */
  CONTROL_OBJECTIVE_CREATE: CONTROL_OBJECTIVE_CREATE,
  CONTROL_OBJECTIVE_VIEW: CONTROL_OBJECTIVE_VIEW,
  CONTROL_OBJECTIVE_VIEW_OWN: CONTROL_OBJECTIVE_VIEW_OWN,
  CONTROL_OBJECTIVE_EDIT: CONTROL_OBJECTIVE_EDIT,
  CONTROL_OBJECTIVE_EDIT_OWN: CONTROL_OBJECTIVE_EDIT_OWN,
  CONTROL_OBJECTIVE_DELETE: CONTROL_OBJECTIVE_DELETE,
  CONTROL_OBJECTIVE_DELETE_OWN: CONTROL_OBJECTIVE_DELETE_OWN,

  /**
   * Assessment permissions
   */
  ASSESSMENT_CREATE: ASSESSMENT_CREATE,
  ASSESSMENT_VIEW: ASSESSMENT_VIEW,
  ASSESSMENT_VIEW_OWN: ASSESSMENT_VIEW_OWN,
  ASSESSMENT_EDIT: ASSESSMENT_EDIT,
  ASSESSMENT_EDIT_OWN: ASSESSMENT_EDIT_OWN,
  ASSESSMENT_DELETE: ASSESSMENT_DELETE,
  ASSESSMENT_DELETE_OWN: ASSESSMENT_DELETE_OWN,

  /**
   * Framework control permissions
   */
  FRAMEWORK_CONTROL_CREATE: FRAMEWORK_CONTROL_CREATE,
  FRAMEWORK_CONTROL_VIEW: FRAMEWORK_CONTROL_VIEW,
  FRAMEWORK_CONTROL_VIEW_OWN: FRAMEWORK_CONTROL_VIEW_OWN,
  FRAMEWORK_CONTROL_EDIT: FRAMEWORK_CONTROL_EDIT,
  FRAMEWORK_CONTROL_EDIT_OWN: FRAMEWORK_CONTROL_EDIT_OWN,
  FRAMEWORK_CONTROL_DELETE: FRAMEWORK_CONTROL_DELETE,
  FRAMEWORK_CONTROL_DELETE_OWN: FRAMEWORK_CONTROL_DELETE_OWN,

  /**
   * Risk scenario permissions
   */
  RISK_SCENARIO_CREATE:RISK_SCENARIO_CREATE,
  RISK_SCENARIO_VIEW:RISK_SCENARIO_VIEW,
  RISK_SCENARIO_VIEW_OWN:RISK_SCENARIO_VIEW_OWN,
  RISK_SCENARIO_EDIT:RISK_SCENARIO_EDIT,
  RISK_SCENARIO_EDIT_OWN:RISK_SCENARIO_EDIT_OWN,
  RISK_SCENARIO_DELETE:RISK_SCENARIO_DELETE,
  RISK_SCENARIO_DELETE_OWN:RISK_SCENARIO_DELETE_OWN,
  RISK_SCENARIO_VALIDATE:RISK_SCENARIO_VALIDATE,
  RISK_SCENARIO_VALIDATE_OWN:RISK_SCENARIO_VALIDATE_OWN,

  /**
   * Risk scenarion threat permissions
   */
  RISK_SCENARIO_THREAT_CREATE:RISK_SCENARIO_THREAT_CREATE,
  RISK_SCENARIO_THREAT_CREATE_OWN: RISK_SCENARIO_THREAT_CREATE_OWN,
  RISK_SCENARIO_THREAT_VIEW: RISK_SCENARIO_THREAT_VIEW,
  RISK_SCENARIO_THREAT_VIEW_OWN: RISK_SCENARIO_THREAT_VIEW_OWN,
  RISK_SCENARIO_THREAT_EDIT: RISK_SCENARIO_THREAT_EDIT,
  RISK_SCENARIO_THREAT_EDIT_OWN: RISK_SCENARIO_THREAT_EDIT_OWN,
  RISK_SCENARIO_THREAT_DELETE: RISK_SCENARIO_THREAT_DELETE,
  RISK_SCENARIO_THREAT_DELETE_OWN: RISK_SCENARIO_THREAT_DELETE_OWN,
  RISK_SCENARIO_THREAT_VALIDATE: RISK_SCENARIO_THREAT_VALIDATE,
  RISK_SCENARIO_THREAT_VALIDATE_OWN: RISK_SCENARIO_THREAT_VALIDATE_OWN,

  /**
   * Risk scenario vulnerability permissions
   */
  RISK_SCENARIO_VULNERABILITY_CREATE: RISK_SCENARIO_VULNERABILITY_CREATE,
  RISK_SCENARIO_VULNERABILITY_CREATE_OWN: RISK_SCENARIO_VULNERABILITY_CREATE_OWN,
  RISK_SCENARIO_VULNERABILITY_VIEW: RISK_SCENARIO_VULNERABILITY_VIEW,
  RISK_SCENARIO_VULNERABILITY_VIEW_OWN: RISK_SCENARIO_VULNERABILITY_VIEW_OWN,
  RISK_SCENARIO_VULNERABILITY_EDIT: RISK_SCENARIO_VULNERABILITY_EDIT,
  RISK_SCENARIO_VULNERABILITY_EDIT_OWN: RISK_SCENARIO_VULNERABILITY_EDIT_OWN,
  RISK_SCENARIO_VULNERABILITY_DELETE: RISK_SCENARIO_VULNERABILITY_DELETE,
  RISK_SCENARIO_VULNERABILITY_DELETE_OWN: RISK_SCENARIO_VULNERABILITY_DELETE_OWN,
  RISK_SCENARIO_VULNERABILITY_VALIDATE: RISK_SCENARIO_VULNERABILITY_VALIDATE,
  RISK_SCENARIO_VULNERABILITY_VALIDATE_OWN: RISK_SCENARIO_VULNERABILITY_VALIDATE_OWN,

  /**
   * Generic control permissions
   */
  GENERIC_CONTROL_CREATE: GENERIC_CONTROL_CREATE,
  GENERIC_CONTROL_VIEW: GENERIC_CONTROL_VIEW,
  GENERIC_CONTROL_VIEW_OWN: GENERIC_CONTROL_VIEW_OWN,
  GENERIC_CONTROL_EDIT: GENERIC_CONTROL_EDIT,
  GENERIC_CONTROL_EDIT_OWN: GENERIC_CONTROL_EDIT_OWN,
  GENERIC_CONTROL_DELETE: GENERIC_CONTROL_DELETE,
  GENERIC_CONTROL_DELETE_OWN: GENERIC_CONTROL_DELETE_OWN,
  GENERIC_CONTROL_VALIDATE: GENERIC_CONTROL_VALIDATE,
  GENERIC_CONTROL_VALIDATE_OWN: GENERIC_CONTROL_VALIDATE_OWN,

  /**
   * Generic control policy permissions
   */
  GENERIC_CONTROL_POLICY_CREATE: GENERIC_CONTROL_POLICY_CREATE,
  GENERIC_CONTROL_POLICY_CREATE_OWN: GENERIC_CONTROL_POLICY_CREATE_OWN,
  GENERIC_CONTROL_POLICY_VIEW: GENERIC_CONTROL_POLICY_VIEW,
  GENERIC_CONTROL_POLICY_VIEW_OWN: GENERIC_CONTROL_POLICY_VIEW_OWN,
  GENERIC_CONTROL_POLICY_EDIT: GENERIC_CONTROL_POLICY_EDIT,
  GENERIC_CONTROL_POLICY_EDIT_OWN: GENERIC_CONTROL_POLICY_EDIT_OWN,
  GENERIC_CONTROL_POLICY_DELETE: GENERIC_CONTROL_POLICY_DELETE,
  GENERIC_CONTROL_POLICY_DELETE_OWN: GENERIC_CONTROL_POLICY_DELETE_OWN,

  /**
   * Generic control framework permissions
   */
  GENERIC_CONTROL_FRAMEWORK_CREATE: GENERIC_CONTROL_FRAMEWORK_CREATE,
  GENERIC_CONTROL_FRAMEWORK_CREATE_OWN: GENERIC_CONTROL_FRAMEWORK_CREATE_OWN,
  GENERIC_CONTROL_FRAMEWORK_VIEW: GENERIC_CONTROL_FRAMEWORK_VIEW,
  GENERIC_CONTROL_FRAMEWORK_VIEW_OWN: GENERIC_CONTROL_FRAMEWORK_VIEW_OWN,
  GENERIC_CONTROL_FRAMEWORK_EDIT: GENERIC_CONTROL_FRAMEWORK_EDIT,
  GENERIC_CONTROL_FRAMEWORK_EDIT_OWN: GENERIC_CONTROL_FRAMEWORK_EDIT_OWN,
  GENERIC_CONTROL_FRAMEWORK_DELETE: GENERIC_CONTROL_FRAMEWORK_DELETE,
  GENERIC_CONTROL_FRAMEWORK_DELETE_OWN: GENERIC_CONTROL_FRAMEWORK_DELETE_OWN,

  /**
   * Generic control risk scenario permissions
   */
  GENERIC_CONTROL_RISK_SCENARIO_CREATE: GENERIC_CONTROL_RISK_SCENARIO_CREATE,
  GENERIC_CONTROL_RISK_SCENARIO_CREATE_OWN: GENERIC_CONTROL_RISK_SCENARIO_CREATE_OWN,
  GENERIC_CONTROL_RISK_SCENARIO_VIEW: GENERIC_CONTROL_RISK_SCENARIO_VIEW,
  GENERIC_CONTROL_RISK_SCENARIO_VIEW_OWN: GENERIC_CONTROL_RISK_SCENARIO_VIEW_OWN,
  GENERIC_CONTROL_RISK_SCENARIO_EDIT: GENERIC_CONTROL_RISK_SCENARIO_EDIT,
  GENERIC_CONTROL_RISK_SCENARIO_EDIT_OWN: GENERIC_CONTROL_RISK_SCENARIO_EDIT_OWN,
  GENERIC_CONTROL_RISK_SCENARIO_DELETE: GENERIC_CONTROL_RISK_SCENARIO_DELETE,
  GENERIC_CONTROL_RISK_SCENARIO_DELETE_OWN: GENERIC_CONTROL_RISK_SCENARIO_DELETE_OWN,

  /**
   * Generic control threat permissions
   */
  GENERIC_CONTROL_THREAT_CREATE: GENERIC_CONTROL_THREAT_CREATE,
  GENERIC_CONTROL_THREAT_CREATE_OWN: GENERIC_CONTROL_THREAT_CREATE_OWN,
  GENERIC_CONTROL_THREAT_VIEW: GENERIC_CONTROL_THREAT_VIEW,
  GENERIC_CONTROL_THREAT_VIEW_OWN: GENERIC_CONTROL_THREAT_VIEW_OWN,
  GENERIC_CONTROL_THREAT_EDIT: GENERIC_CONTROL_THREAT_EDIT,
  GENERIC_CONTROL_THREAT_EDIT_OWN: GENERIC_CONTROL_THREAT_EDIT_OWN,
  GENERIC_CONTROL_THREAT_DELETE: GENERIC_CONTROL_THREAT_DELETE,
  GENERIC_CONTROL_THREAT_DELETE_OWN: GENERIC_CONTROL_THREAT_DELETE_OWN,

  /**
   * Generic control vulnerability permissions
   */
  GENERIC_CONTROL_VULNERABILITY_CREATE: GENERIC_CONTROL_VULNERABILITY_CREATE,
  GENERIC_CONTROL_VULNERABILITY_CREATE_OWN: GENERIC_CONTROL_VULNERABILITY_CREATE_OWN,
  GENERIC_CONTROL_VULNERABILITY_VIEW: GENERIC_CONTROL_VULNERABILITY_VIEW,
  GENERIC_CONTROL_VULNERABILITY_VIEW_OWN: GENERIC_CONTROL_VULNERABILITY_VIEW_OWN,
  GENERIC_CONTROL_VULNERABILITY_EDIT: GENERIC_CONTROL_VULNERABILITY_EDIT,
  GENERIC_CONTROL_VULNERABILITY_EDIT_OWN: GENERIC_CONTROL_VULNERABILITY_EDIT_OWN,
  GENERIC_CONTROL_VULNERABILITY_DELETE: GENERIC_CONTROL_VULNERABILITY_DELETE,
  GENERIC_CONTROL_VULNERABILITY_DELETE_OWN: GENERIC_CONTROL_VULNERABILITY_DELETE_OWN,

  /**
   * System risk scenario permissions
   */
  SYSTEM_RISK_SCENARIO_CREATE: SYSTEM_RISK_SCENARIO_CREATE,
  SYSTEM_RISK_SCENARIO_CREATE_OWN: SYSTEM_RISK_SCENARIO_CREATE_OWN,
  SYSTEM_RISK_SCENARIO_VIEW: SYSTEM_RISK_SCENARIO_VIEW,
  SYSTEM_RISK_SCENARIO_VIEW_OWN: SYSTEM_RISK_SCENARIO_VIEW_OWN,
  SYSTEM_RISK_SCENARIO_EDIT: SYSTEM_RISK_SCENARIO_EDIT,
  SYSTEM_RISK_SCENARIO_EDIT_OWN: SYSTEM_RISK_SCENARIO_EDIT_OWN,
  SYSTEM_RISK_SCENARIO_DELETE: SYSTEM_RISK_SCENARIO_DELETE,
  SYSTEM_RISK_SCENARIO_DELETE_OWN: SYSTEM_RISK_SCENARIO_DELETE_OWN,
  SYSTEM_RISK_SCENARIO_VALIDATE: SYSTEM_RISK_SCENARIO_VALIDATE,
  SYSTEM_RISK_SCENARIO_VALIDATE_OWN: SYSTEM_RISK_SCENARIO_VALIDATE_OWN,


  /**
   * Process risk scenario permissions
   */
  PROCESS_RISK_SCENARIO_CREATE: PROCESS_RISK_SCENARIO_CREATE,
  PROCESS_RISK_SCENARIO_CREATE_OWN: PROCESS_RISK_SCENARIO_CREATE_OWN,
  PROCESS_RISK_SCENARIO_VIEW: PROCESS_RISK_SCENARIO_VIEW,
  PROCESS_RISK_SCENARIO_VIEW_OWN: PROCESS_RISK_SCENARIO_VIEW_OWN,
  PROCESS_RISK_SCENARIO_EDIT: PROCESS_RISK_SCENARIO_EDIT,
  PROCESS_RISK_SCENARIO_EDIT_OWN: PROCESS_RISK_SCENARIO_EDIT_OWN,
  PROCESS_RISK_SCENARIO_DELETE: PROCESS_RISK_SCENARIO_DELETE,
  PROCESS_RISK_SCENARIO_DELETE_OWN: PROCESS_RISK_SCENARIO_DELETE_OWN,
  PROCESS_RISK_SCENARIO_VALIDATE: PROCESS_RISK_SCENARIO_VALIDATE,
  PROCESS_RISK_SCENARIO_VALIDATE_OWN: PROCESS_RISK_SCENARIO_VALIDATE_OWN,

  /**
   * Third party risk scenario permissions
   */
  THIRD_PARTY_RISK_SCENARIO_CREATE: THIRD_PARTY_RISK_SCENARIO_CREATE,
  THIRD_PARTY_RISK_SCENARIO_CREATE_OWN: THIRD_PARTY_RISK_SCENARIO_CREATE_OWN,
  THIRD_PARTY_RISK_SCENARIO_VIEW: THIRD_PARTY_RISK_SCENARIO_VIEW,
  THIRD_PARTY_RISK_SCENARIO_VIEW_OWN: THIRD_PARTY_RISK_SCENARIO_VIEW_OWN,
  THIRD_PARTY_RISK_SCENARIO_EDIT: THIRD_PARTY_RISK_SCENARIO_EDIT,
  THIRD_PARTY_RISK_SCENARIO_EDIT_OWN: THIRD_PARTY_RISK_SCENARIO_EDIT_OWN,
  THIRD_PARTY_RISK_SCENARIO_DELETE: THIRD_PARTY_RISK_SCENARIO_DELETE,
  THIRD_PARTY_RISK_SCENARIO_DELETE_OWN: THIRD_PARTY_RISK_SCENARIO_DELETE_OWN,
  THIRD_PARTY_RISK_SCENARIO_VALIDATE: THIRD_PARTY_RISK_SCENARIO_VALIDATE,
  THIRD_PARTY_RISK_SCENARIO_VALIDATE_OWN: THIRD_PARTY_RISK_SCENARIO_VALIDATE_OWN,


  /**
   * Third party documents permissions
   */
  THIRD_PARTY_DOCUMENT_CREATE: THIRD_PARTY_DOCUMENT_CREATE,
  THIRD_PARTY_DOCUMENT_CREATE_OWN: THIRD_PARTY_DOCUMENT_CREATE_OWN,
  THIRD_PARTY_DOCUMENT_VIEW: THIRD_PARTY_DOCUMENT_VIEW,
  THIRD_PARTY_DOCUMENT_VIEW_OWN: THIRD_PARTY_DOCUMENT_VIEW_OWN,
  THIRD_PARTY_DOCUMENT_EDIT: THIRD_PARTY_DOCUMENT_EDIT,
  THIRD_PARTY_DOCUMENT_EDIT_OWN: THIRD_PARTY_DOCUMENT_EDIT_OWN,
  THIRD_PARTY_DOCUMENT_DELETE: THIRD_PARTY_DOCUMENT_DELETE,
  THIRD_PARTY_DOCUMENT_DELETE_OWN: THIRD_PARTY_DOCUMENT_DELETE_OWN,
  THIRD_PARTY_DOCUMENT_VALIDATE: THIRD_PARTY_DOCUMENT_VALIDATE,
  THIRD_PARTY_DOCUMENT_VALIDATE_OWN: THIRD_PARTY_DOCUMENT_VALIDATE_OWN,


  /**
   * Third party documents permissions
   */
  POLICY_DOCUMENT_CREATE: POLICY_DOCUMENT_CREATE,
  POLICY_DOCUMENT_CREATE_OWN: POLICY_DOCUMENT_CREATE_OWN,
  POLICY_DOCUMENT_VIEW: POLICY_DOCUMENT_VIEW,
  POLICY_DOCUMENT_VIEW_OWN: POLICY_DOCUMENT_VIEW_OWN,
  POLICY_DOCUMENT_EDIT: POLICY_DOCUMENT_EDIT,
  POLICY_DOCUMENT_EDIT_OWN: POLICY_DOCUMENT_EDIT_OWN,
  POLICY_DOCUMENT_DELETE: POLICY_DOCUMENT_DELETE,
  POLICY_DOCUMENT_DELETE_OWN: POLICY_DOCUMENT_DELETE_OWN,
  POLICY_DOCUMENT_VALIDATE: POLICY_DOCUMENT_VALIDATE,
  POLICY_DOCUMENT_VALIDATE_OWN: POLICY_DOCUMENT_VALIDATE_OWN,

}
